/* Yogi Adhiraaj shop chrome. Vanilla JS, Hostinger-ready. */
(function () {
  "use strict";
  const WA = "919016872214";
  const DEAL_KEY = "ya-deal-until-v3";
  const DEAL_MS = (60 * 60 + 20) * 1000;
  const CART_KEY = "ya-cart";
  const COUPON_KEY = "ya-coupon-session-v1";
  const OTP_KEY = "ya-coupon-otp-v1";
  const COUPON_CODE = "adhiraaj10";
  const GOOGLE_KEY = "ya-google-user";
  const KNOWN_KEY = "ya-google-known";

  const $ = (sel, root) => (root || document).querySelector(sel);
  const $$ = (sel, root) => Array.from((root || document).querySelectorAll(sel));

  window.YA = window.YA || {};
  const YA = window.YA;
  // Shopify product records replace the old, hardcoded catalogue on storefront pages.
  try {
    const source = document.getElementById('ya-shopify-products');
    if (source) {
      window.YA_SHOPIFY_MODE = true;
      const old = Array.isArray(YA.PRODUCTS) ? YA.PRODUCTS : [];
      YA.PRODUCTS = JSON.parse(source.textContent || '[]').map(function (product) {
        const editorial = old.find(function (p) {
          return p.slug === product.slug || p.title.toLowerCase() === product.title.toLowerCase();
        });
        return Object.assign({}, editorial || {}, product, { legacySlug: editorial && editorial.slug,
          image: product.image, sale: product.sale,
          mrp: product.mrp, available: product.available, url: product.url, categories: product.categories });
      });
    }
  } catch (e) { YA.PRODUCTS = []; }

  YA.formatINR = function (n) {
    return "₹" + Math.round(Number(n) || 0).toLocaleString("en-IN");
  };
  function escapeHTML(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }
  YA.formatPaise = function (n) {
    const x = Number(n) || 0;
    const [whole, frac] = x.toFixed(2).split(".");
    return "₹" + Number(whole).toLocaleString("en-IN") + "." + frac;
  };
  YA.salePercent = function (p) {
    if (!p || !p.mrp || p.mrp <= p.sale) return 0;
    return Math.round(((p.mrp - p.sale) / p.mrp) * 100);
  };
  YA.isFlagship = function (p) {
    if (!p) return false;
    if (p.slug === "dhan-aakarshan-mahayantra" || p.slug === "vishesh-manokamna-mahayantra") return true;
    const t = (p.title || "").toLowerCase();
    if ((p.title || "").includes("+")) return false;
    return t.includes("manokamna") || t.includes("kaamna") || t.includes("dhan aakarshan") || t.includes("dhanaakarshan");
  };
  YA.productHref = function (p) {
    if (!p) return "/collections/all";
    if (p.url) return p.url;
    if (p.landing) return p.landing;
    return "/products/" + p.slug;
  };
  YA.waUrl = function (text) {
    return "https://wa.me/" + WA + "?text=" + encodeURIComponent(text);
  };
  YA.getProduct = function (id) {
    const list = YA.PRODUCTS || [];
    const aliases = YA.SLUG_ALIASES || {};
    const key = String(id || "").split(":")[0].trim();
    const aliased = aliases[key] || key;
    return list.find((p) => String(p.id) === key || p.slug === key || p.legacySlug === key ||
      String(p.id) === aliased || p.slug === aliased || p.legacySlug === aliased) || null;
  };
  YA.categoryKey = function (raw) {
    const v = (raw || "yantras").toLowerCase();
    if (v === "all") return "all";
    if (v === "bundles" || v === "combos" || v === "bogo") return "bundles";
    if (v === "vajras" || v === "vjras" || v === "vajra") return "VJRAS";
    if (v === "manibadh" || v === "manibaddh" || v === "manibadhh") return "MANIBADHH";
    if (v === "itram" || v === "itra" || v === "itras") return "ITRA";
    if (v === "yantras" || v === "yantra") return "YANTRAS";
    return v.toUpperCase();
  };
  YA.productsIn = function (category, purpose) {
    let list = (YA.PRODUCTS || []).slice();
    if (category && String(category).toLowerCase() !== "all") {
      const key = YA.categoryKey(category);
      if (key === "bundles") list = list.filter((p) => p.bogo || p.bundle);
      else list = list.filter((p) => (p.categories || []).some((c) => String(c).toUpperCase() === key));
    }
    if (purpose && String(purpose).toLowerCase() !== "all") {
      if (purpose === "bundles") list = list.filter((p) => p.bogo || p.bundle);
      else list = list.filter((p) => (p.purposes || []).some((t) => { t = String(t).toLowerCase(); return t === purpose || t === "purpose:" + purpose; }));
    }
    return list;
  };
  YA.sortProducts = function (list, sort) {
    const arr = list.slice();
    if (sort === "price_asc") return arr.sort((a, b) => a.sale - b.sale);
    if (sort === "price_desc") return arr.sort((a, b) => b.sale - a.sale);
    if (sort === "name_asc") return arr.sort((a, b) => a.title.localeCompare(b.title));
    if (sort === "name_desc") return arr.sort((a, b) => b.title.localeCompare(a.title));
    return arr;
  };
  YA.searchProducts = function (query, limit) {
    const q = String(query || "").toLowerCase().trim();
    if (!q) return [];
    const words = q.split(/\s+/).filter((w) => w.length > 1);
    return (YA.PRODUCTS || [])
      .map((p) => {
        const title = p.title.toLowerCase();
        const hay = (title + " " + (p.subtitle || "") + " " + (p.ribbon || "") + " " + (p.categories || []).join(" ")).toLowerCase();
        let score = 0;
        if (title.includes(q)) score += 12;
        if (hay.includes(q)) score += 4;
        words.forEach((w) => {
          if (title.includes(w)) score += 3;
          else if (hay.includes(w)) score += 1;
        });
        return { p, score };
      })
      .filter((s) => s.score > 0)
      .sort((a, b) => b.score - a.score)
      .slice(0, limit || 8)
      .map((s) => s.p);
  };

  function lockScroll(on) {
    document.body.style.overflow = on ? "hidden" : "";
    document.documentElement.style.overflow = on ? "hidden" : "";
  }
  function clearChrome() {
    Object.keys(SHEET_SEL).forEach(closeSheet);
    const drawer = $(".cat-drawer");
    if (drawer) {
      drawer.classList.remove("is-open");
      drawer.hidden = true;
      drawer.setAttribute("aria-hidden", "true");
    }
    lockScroll(false);
  }

  const SHEET_SEL = {
    coupon: "[data-coupon]",
    kmm: "[data-kmm]",
    google: "[data-google-sheet]",
    hold: "[data-hold]",
    search: "[data-search]",
  };

  function sheetEl(name) {
    return $(SHEET_SEL[name]);
  }
  function sheetIsOpen(name) {
    const el = sheetEl(name);
    return !!(el && !el.hidden);
  }
  function anySheetOpen(except) {
    return Object.keys(SHEET_SEL).some(function (n) {
      return n !== except && sheetIsOpen(n);
    });
  }
  function closeSheet(name) {
    const el = sheetEl(name);
    if (!el || el.hidden) return;
    el.hidden = true;
    el.setAttribute("aria-hidden", "true");
  }
  function closeOtherSheets(keep) {
    Object.keys(SHEET_SEL).forEach(function (n) {
      if (n !== keep) closeSheet(n);
    });
  }
  function openSheet(name) {
    closeOtherSheets(name);
    const el = sheetEl(name);
    if (!el) return null;
    el.hidden = false;
    el.removeAttribute("hidden");
    el.setAttribute("aria-hidden", "false");
    lockScroll(true);
    return el;
  }
  function releaseSheet(name) {
    closeSheet(name);
    if (!anySheetOpen()) lockScroll(false);
  }

  function readCart() {
    try {
      const raw = JSON.parse(localStorage.getItem(CART_KEY) || "");
      if (raw && raw.state && Array.isArray(raw.state.lines)) return raw.state.lines;
      if (raw && Array.isArray(raw.lines)) return raw.lines;
    } catch (e) {}
    return [];
  }
  function writeCart(lines) {
    try {
      localStorage.setItem(CART_KEY, JSON.stringify({ state: { lines: lines }, version: 0 }));
    } catch (e) {}
    paintCart();
    window.dispatchEvent(new CustomEvent("ya-cart"));
  }
  YA.cartLines = readCart;
  YA.cartCount = function () {
    return readCart().reduce((n, l) => n + (l.qty || 0), 0);
  };
  YA.cartAdd = function (product, qty, opts) {
    opts = opts || {};
    qty = qty || 1;
    const lines = readCart();
    const id = opts.lineId || product.id;
    const found = lines.find((l) => l.id === id);
    if (found) found.qty += qty;
    else {
      lines.push({
        id: id,
        productId: product.id,
        title: opts.title || product.title,
        image: product.image,
        price: opts.price != null ? opts.price : YA.isDealClaimed() ? product.sale : product.mrp || product.sale,
        qty: qty,
      });
    }
    writeCart(lines);
    if (YA.journey) {
      YA.journey.track("add_to_cart", { item_id: product.slug || product.id, value: opts.price != null ? opts.price : product.sale });
    }
  };
  YA.cartSetQty = function (id, qty) {
    let lines = readCart();
    if (qty <= 0) lines = lines.filter((l) => l.id !== id);
    else lines = lines.map((l) => (l.id === id ? Object.assign({}, l, { qty: qty }) : l));
    writeCart(lines);
  };
  YA.cartRemove = function (id) {
    writeCart(readCart().filter((l) => l.id !== id));
  };
  YA.cartClear = function () {
    writeCart([]);
  };

  function initHeaderBrand() {
    fetch("https://www.yogiadhiraajproducts.in/api/desk.php?mode=public")
      .then(function (r) { return r.json(); })
      .then(function (d) {
        const logo = d && d.house && d.house.logo;
        if (!logo || logo[0] !== "/") return;
        $$("img.brand-logo, header a[aria-label='Yogi Adhiraaj home'] img, .ad-top img").forEach(function (img) {
          img.src = logo;
        });
      })
      .catch(function () {});
  }
  function paintCart() {
    fetch('/cart.js').then(function (response) { return response.json(); }).then(function (cart) {
      const n = cart.item_count || 0;
      $$("[data-cart-count]").forEach(function (el) { el.textContent = String(n); el.hidden = n < 1; });
      $$("[data-cart-label]").forEach(function (el) { el.textContent = "View Cart (" + n + ")"; });
    }).catch(function () {});
  }

  function getDealUntil() {
    try {
      const n = Number(localStorage.getItem(DEAL_KEY) || 0);
      return n > Date.now() ? n : 0;
    } catch (e) {
      return 0;
    }
  }
  YA.isDealClaimed = function () {
    return getDealUntil() > Date.now();
  };
  YA.dealUnit = function (product) {
    if (!product) return 0;
    return YA.isDealClaimed() ? Number(product.sale) : Number(product.mrp || product.sale);
  };
  YA.claimDeal = function (opts) {
    opts = opts || {};
    if (!YA.isDealClaimed()) {
      try {
        localStorage.setItem(DEAL_KEY, String(Date.now() + DEAL_MS));
      } catch (e) {}
    }
    paintStaticPrices();
    $$("[data-save-deal]").forEach(function (el) {
      buildSaveDeal(el);
      if (opts.roll !== false) rollSaveDeal(el);
    });
    window.dispatchEvent(new CustomEvent("ya-deal"));
    return getDealUntil();
  };

  function clockParts(ms) {
    const t = Math.max(0, ms);
    const totalSec = Math.floor(t / 1000);
    const pad = (n) => String(n).padStart(2, "0");
    return { m: pad(Math.floor(totalSec / 60)), s: pad(totalSec % 60), ms: pad(Math.floor((t % 1000) / 10)) };
  }

  const BURST_COLORS = ["#F6EE03", "#FFFFFF", "#D4AF37", "#FBBF24", "#FFE566", "#FFD700", "#FFF8DC", "#E8B923"];
  let dealViewStart = Date.now();
  let dealRolling = false;
  let dealArmed = false;

  function reducedMotion() {
    try {
      return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    } catch (e) {
      return false;
    }
  }

  function burstRoot() {
    let el = document.getElementById("ya-burst-root");
    if (el) return el;
    el = document.createElement("div");
    el.id = "ya-burst-root";
    el.setAttribute("aria-hidden", "true");
    el.style.cssText =
      "position:fixed;inset:0;width:100vw;height:100vh;pointer-events:none;z-index:2147483646;overflow:visible";
    const style = document.createElement("style");
    style.textContent =
      "@keyframes ya-burst-fly{0%{opacity:1;transform:translate(0,0) scale(1.2) rotate(0)}100%{opacity:0;transform:translate(var(--sx,0px),var(--sy,-70px)) scale(.2) rotate(var(--rot,40deg))}}" +
      "@keyframes ya-burst-core-kf{0%{transform:scale(.2);opacity:1}100%{transform:scale(1.7);opacity:0}}" +
      "@keyframes ya-burst-ring-kf{0%{transform:scale(.3);opacity:1}100%{transform:scale(2.1);opacity:0}}" +
      "#ya-burst-root .ya-burst-dot{position:absolute;left:0;top:0;pointer-events:none;animation:ya-burst-fly .9s cubic-bezier(.15,.8,.25,1) forwards}" +
      "#ya-burst-root .ya-burst-star{clip-path:polygon(50% 0%,61% 35%,98% 35%,68% 57%,79% 91%,50% 70%,21% 91%,32% 57%,2% 35%,39% 35%);border-radius:0}" +
      "#ya-burst-root .ya-burst-core{position:absolute;left:0;top:0;width:40px;height:40px;margin:-20px 0 0 -20px;border-radius:50%;background:radial-gradient(circle,#fff 0%,#F6EE03 34%,#D4AF37 62%,transparent 74%);box-shadow:0 0 24px 10px rgba(246,238,3,.9);animation:ya-burst-core-kf .55s ease-out forwards}" +
      "#ya-burst-root .ya-burst-ring{position:absolute;left:0;top:0;width:44px;height:44px;margin:-22px 0 0 -22px;border-radius:50%;border:2px solid #F6EE03;box-shadow:0 0 14px rgba(246,238,3,.9);animation:ya-burst-ring-kf .7s ease-out forwards}";
    el.appendChild(style);
    document.body.appendChild(el);
    return el;
  }

  function sparkleBurst(origin, count) {
    if (reducedMotion() || !origin) return;
    const wrap = document.createElement("div");
    wrap.style.cssText =
      "position:fixed;left:" +
      origin.x +
      "px;top:" +
      origin.y +
      "px;width:0;height:0;z-index:2147483647;overflow:visible;pointer-events:none";
    const n = Math.min(36, count || 32);
    let html = '<span class="ya-burst-core"></span><span class="ya-burst-ring"></span><span class="ya-burst-ring ya-burst-ring-delay"></span>';
    for (let i = 0; i < n; i++) {
      const angle = (i / n) * Math.PI * 2 + (i % 4) * 0.08;
      const dist = 36 + (i % 6) * 14;
      const x = Math.cos(angle) * dist;
      const y = Math.sin(angle) * dist * 0.86 - 10;
      const size = 6 + (i % 5) * 2;
      const isStar = i % 4 === 0;
      const isDiamond = i % 5 === 0;
      const kind = isStar ? " ya-burst-star" : isDiamond ? " ya-burst-diamond" : "";
      const rot = (i % 2 === 0 ? 1 : -1) * (30 + (i % 5) * 18);
      const color = BURST_COLORS[i % BURST_COLORS.length];
      html +=
        '<span class="ya-burst-dot' +
        kind +
        '" style="width:' +
        size +
        "px;height:" +
        size +
        "px;margin-left:" +
        -size / 2 +
        "px;margin-top:" +
        -size / 2 +
        "px;background:" +
        color +
        ";border-radius:" +
        (isStar || isDiamond ? "0" : "50%") +
        ";box-shadow:0 0 8px 2px " +
        color +
        ";--sx:" +
        x +
        "px;--sy:" +
        y +
        "px;--rot:" +
        rot +
        'deg"></span>';
    }
    wrap.innerHTML = html;
    burstRoot().appendChild(wrap);
    window.setTimeout(function () {
      wrap.remove();
    }, 1100);
  }

  function flashButton(btn) {
    if (!btn || reducedMotion()) return;
    const style = window.getComputedStyle(btn);
    if (style.position === "static") btn.style.position = "relative";
    const prev = btn.querySelector(".ya-btn-flash");
    if (prev) prev.remove();
    const flash = document.createElement("span");
    flash.className = "ya-btn-flash";
    flash.setAttribute("aria-hidden", "true");
    btn.appendChild(flash);
    btn.classList.add("is-burst");
    window.setTimeout(function () {
      flash.remove();
      btn.classList.remove("is-burst");
    }, 360);
  }

  function burstAtButton(btn, fallback) {
    if (reducedMotion()) return;
    if (btn) {
      flashButton(btn);
      const r = btn.getBoundingClientRect();
      sparkleBurst({ x: r.left + r.width / 2, y: r.top + r.height / 2 }, 32);
      return;
    }
    if (fallback) sparkleBurst(fallback, 32);
  }

  function dealLeft() {
    if (YA.isDealClaimed()) return Math.max(0, getDealUntil() - Date.now());
    return Math.max(0, DEAL_MS - (Date.now() - dealViewStart));
  }

  function paintStaticPrices() {
    const claimed = window.YA_SHOPIFY_MODE || YA.isDealClaimed();
    $$("[data-sale][data-mrp]").forEach((el) => {
      if (el.hasAttribute("data-save-deal")) return;
      const sale = Number(el.getAttribute("data-sale"));
      const mrp = Number(el.getAttribute("data-mrp"));
      const pct = mrp > sale ? Math.round(((mrp - sale) / mrp) * 100) : 0;
      if (pct <= 0) {
        el.innerHTML = "<b>" + YA.formatINR(sale) + "</b>";
        return;
      }
      el.innerHTML = claimed
        ? "<s>" + YA.formatINR(mrp) + "</s><b>" + YA.formatINR(sale) + "</b>"
        : "<b>" + YA.formatINR(mrp) + "</b>";
    });
  }

  function paintPrices() {
    $$(".pcard-price [data-sale][data-mrp], [data-save-deal]").forEach(function (el) {
      if (!el.hasAttribute("data-save-deal")) {
        el.setAttribute("data-save-deal", "");
        if (!el.getAttribute("data-deal-size")) el.setAttribute("data-deal-size", "card");
      }
    });
    paintStaticPrices();
    $$("[data-save-deal]").forEach(function (el) {
      buildSaveDeal(el);
      refreshSaveDeal(el, true);
    });
  }

  function buildSaveDeal(el) {
    if (el.getAttribute("data-deal-ready") === "1" && el.querySelector("[data-claim-deal]")) return;
    const sale = Number(el.getAttribute("data-sale"));
    const mrp = Number(el.getAttribute("data-mrp"));
    const size = el.getAttribute("data-deal-size") || "pdp";
    const pct = mrp > sale ? Math.round(((mrp - sale) / mrp) * 100) : 0;
    if (pct <= 0 || window.YA_SHOPIFY_MODE) {
      el.innerHTML = '<span class="deal-price deal-price-' + size + '">' + YA.formatINR(sale) + "</span>";
      el.setAttribute("data-deal-ready", "1");
      return;
    }
    const claimed = YA.isDealClaimed();
    const clock = clockParts(dealLeft());
    const shown = claimed ? sale : mrp;
    const saveBtn =
      '<button type="button" class="deal-save' +
      (claimed ? " is-done" : "") +
      '" data-claim-deal aria-pressed="' +
      claimed +
      '" aria-label="' +
      (claimed ? "Saved " + pct + " percent. Offer reserved." : "Save " + pct + " percent") +
      '">' +
      (claimed ? "Saved " + pct + "%" : "Save " + pct + "%") +
      "</button>";
    const prices =
      '<span class="deal-prices"><span class="deal-price deal-price-' +
      size +
      (claimed ? " is-landed" : "") +
      '" data-deal-price>' +
      YA.formatINR(shown) +
      "</span>" +
      (claimed
        ? '<span class="deal-mrp">' + YA.formatINR(mrp) + "</span>"
        : '<span class="deal-mrp" hidden>' + YA.formatINR(mrp) + "</span>") +
      "</span>";
    if (size === "card" || size === "compact") {
      el.innerHTML =
        '<div class="deal deal-' +
        size +
        '"><div class="deal-row">' +
        prices +
        saveBtn +
        "</div></div>";
      el.setAttribute("data-deal-ready", "1");
      return;
    }
    el.innerHTML =
      '<div class="deal deal-pdp"><div class="deal-lock">' +
      '<div class="deal-clock-row"><div class="deal-clock-main">' +
      '<div class="deal-clock" role="timer" aria-live="off">' +
      '<span class="deal-clock-face' +
      (claimed ? " is-live" : "") +
      '"><span class="deal-clock-ticks" aria-hidden></span>' +
      '<span class="deal-clock-unit"><b data-clock-m>' +
      clock.m +
      "</b><small>min</small></span>" +
      '<span class="deal-clock-sep" aria-hidden>:</span>' +
      '<span class="deal-clock-unit"><b data-clock-s>' +
      clock.s +
      "</b><small>sec</small></span>" +
      '<span class="deal-clock-sep is-ms" aria-hidden>:</span>' +
      '<span class="deal-clock-unit is-ms"><b data-clock-ms>' +
      clock.ms +
      "</b><small>ms</small></span></span></div>" +
      saveBtn +
      "</div>" +
      '<div class="deal-clock-aside">' +
      prices +
      "</div></div>" +
      '<p class="deal-clock-kicker' +
      (claimed ? " is-live" : "") +
      '" data-deal-kicker>' +
      (claimed ? "Offer <span>reserved</span>" : "Price lock <span>ticking</span>") +
      "</p>" +
      '<p class="deal-clock-urgent' +
      (claimed ? " is-live" : "") +
      '" data-deal-urgent>' +
      (claimed
        ? '<span class="deal-clock-urgent-pulse">Hurry</span><span class="deal-clock-urgent-en">Saved price lifts at zero. Checkout now.</span><span class="deal-clock-urgent-hi">Aapka lock isi clock tak. Abhi poora kijiye.</span>'
        : '<span class="deal-clock-urgent-pulse">Jaldi kijiye</span><span class="deal-clock-urgent-en">This window is already ticking. Tap Save to lock the price.</span><span class="deal-clock-urgent-hi">Clock zero hote hi yeh daam uth jayega.</span>') +
      "</p></div></div>";
    el.setAttribute("data-deal-ready", "1");
  }

  function refreshSaveDeal(el, forcePrice) {
    if (el._rolling) return;
    const claimed = YA.isDealClaimed();
    const sale = Number(el.getAttribute("data-sale"));
    const mrp = Number(el.getAttribute("data-mrp"));
    const pct = mrp > sale ? Math.round(((mrp - sale) / mrp) * 100) : 0;
    if (pct <= 0) return;
    const clock = clockParts(dealLeft());
    const m = el.querySelector("[data-clock-m]");
    const s = el.querySelector("[data-clock-s]");
    const ms = el.querySelector("[data-clock-ms]");
    if (m) m.textContent = clock.m;
    if (s) s.textContent = clock.s;
    if (ms) ms.textContent = clock.ms;
    const face = el.querySelector(".deal-clock-face");
    if (face) face.classList.toggle("is-live", claimed);
    const kicker = el.querySelector("[data-deal-kicker]");
    if (kicker) {
      kicker.classList.toggle("is-live", claimed);
      kicker.innerHTML = claimed ? "Offer <span>reserved</span>" : "Price lock <span>ticking</span>";
    }
    const urgent = el.querySelector("[data-deal-urgent]");
    if (urgent) {
      urgent.classList.toggle("is-live", claimed);
      urgent.innerHTML = claimed
        ? '<span class="deal-clock-urgent-pulse">Hurry</span><span class="deal-clock-urgent-en">Saved price lifts at zero. Checkout now.</span><span class="deal-clock-urgent-hi">Aapka lock isi clock tak. Abhi poora kijiye.</span>'
        : '<span class="deal-clock-urgent-pulse">Jaldi kijiye</span><span class="deal-clock-urgent-en">This window is already ticking. Tap Save to lock the price.</span><span class="deal-clock-urgent-hi">Clock zero hote hi yeh daam uth jayega.</span>';
    }
    const btn = el.querySelector("[data-claim-deal]");
    if (btn) {
      btn.classList.toggle("is-done", claimed && !el._rolling);
      btn.setAttribute("aria-pressed", claimed ? "true" : "false");
      if (!el._rolling) btn.textContent = claimed ? "Saved " + pct + "%" : "Save " + pct + "%";
    }
    if (forcePrice && !el._rolling) {
      const price = el.querySelector("[data-deal-price]");
      const mrpEl = el.querySelector(".deal-mrp");
      if (price) {
        price.textContent = YA.formatINR(claimed ? sale : mrp);
        price.classList.toggle("is-landed", claimed);
      }
      if (mrpEl) mrpEl.hidden = !claimed;
    }
  }

  function rollSaveDeal(el) {
    const sale = Number(el.getAttribute("data-sale"));
    const mrp = Number(el.getAttribute("data-mrp"));
    const pct = mrp > sale ? Math.round(((mrp - sale) / mrp) * 100) : 0;
    const price = el.querySelector("[data-deal-price]");
    const mrpEl = el.querySelector(".deal-mrp");
    const btn = el.querySelector("[data-claim-deal]");
    if (!price || pct <= 0) {
      refreshSaveDeal(el, true);
      return;
    }
    if (el._raf) cancelAnimationFrame(el._raf);
    if (mrpEl) mrpEl.hidden = false;
    if (btn) {
      btn.classList.add("is-busy");
      btn.textContent = "Saved " + pct + "%";
    }
    if (reducedMotion() || mrp <= sale) {
      price.textContent = YA.formatINR(sale);
      price.classList.add("is-landed");
      if (btn) btn.classList.remove("is-busy");
      refreshSaveDeal(el, true);
      return;
    }
    el._rolling = true;
    dealRolling = true;
    price.classList.add("is-rolling");
    price.textContent = YA.formatINR(mrp);
    const dur = 1400;
    const t0 = performance.now();
    const ease = function (t) {
      return 1 - Math.pow(1 - t, 3);
    };
    function tick(stamp) {
      const p = Math.min(1, (stamp - t0) / dur);
      price.textContent = YA.formatINR(Math.round(mrp + (sale - mrp) * ease(p)));
      if (p < 1) {
        el._raf = requestAnimationFrame(tick);
      } else {
        price.textContent = YA.formatINR(sale);
        price.classList.remove("is-rolling");
        price.classList.add("is-landed");
        el._rolling = false;
        dealRolling = false;
        if (btn) {
          btn.classList.remove("is-busy");
          btn.classList.add("is-done");
        }
        refreshSaveDeal(el, true);
      }
    }
    el._raf = requestAnimationFrame(tick);
  }

  function claimNow(btn, fallback) {
    burstAtButton(btn, fallback);
    YA.claimDeal({ roll: true });
    return true;
  }

  function initDeal() {
    dealViewStart = Date.now();
    paintPrices();
    const fromSave = /[?&]claim=1(?:&|$)/.test(location.search);
    if (fromSave) {
      const btn = $("[data-claim-deal]");
      claimNow(btn, btn ? null : { x: window.innerWidth / 2, y: 220 });
    }
    document.addEventListener("pointerdown", function (e) {
      if (e.button && e.button !== 0) return;
      const btn = e.target.closest("[data-claim-deal]");
      if (!btn) return;
      e.preventDefault();
      dealArmed = true;
      claimNow(btn, { x: e.clientX, y: e.clientY });
    });
    document.addEventListener("click", function (e) {
      const btn = e.target.closest("[data-claim-deal]");
      if (!btn) return;
      e.preventDefault();
      if (dealArmed) {
        dealArmed = false;
        return;
      }
      claimNow(btn, { x: e.clientX, y: e.clientY });
    });
    const step = reducedMotion() ? 250 : 40;
    window.setInterval(function () {
      $$("[data-save-deal]").forEach(function (el) {
        refreshSaveDeal(el, false);
      });
    }, step);
  }

  YA.cardHtml = function (p, priority) {
    const flagship = YA.isFlagship(p);
    const pct = YA.salePercent(p);
    let mark = null;
    if (flagship) mark = { text: "Flagship", tone: "flagship" };
    else if (p.available === false) mark = { text: "Unavailable", tone: "maroon" };
    else if (p.bogo) mark = { text: "Buy 1 Get 1", tone: "gold" };
    else if (p.bundle) mark = { text: "Bundle", tone: "gold" };
    else if (pct >= 20) mark = { text: pct + "% Off", tone: "gold" };
    const href = escapeHTML(YA.productHref(p));
    const img = escapeHTML(p.image || "");
    const wa = YA.waUrl("Namaste. I want to know more about " + p.title + ".\nPrice: " + YA.formatINR(p.sale) + "\nPage: " + location.origin + href);
    return (
      '<article class="pcard card-lift group"><a href="' +
      href +
      '" class="pcard-media"><img src="' +
      img +
      '" alt="' +
      escapeHTML(p.title) +
      '" width="600" height="600" loading="' +
      (priority ? "eager" : "lazy") +
      '" decoding="async" class="pcard-img">' +
      (mark ? '<span class="pcard-badge pcard-badge-' + mark.tone + '">' + mark.text + "</span>" : "") +
      '</a><div class="pcard-body"><p class="pcard-ribbon' +
      (flagship ? " is-flagship" : "") +
      '">' +
      escapeHTML(flagship ? "Flagship" : p.ribbon || "Ashram consecrated") +
      '</p><a href="' +
      href +
      '"><h3 class="pcard-title">' +
      escapeHTML(p.title) +
      '</h3></a><p class="pcard-sub">' +
      escapeHTML(p.subtitle || "Handcrafted at Madikeri ashram") +
      '</p><p class="pcard-blurb">' +
      escapeHTML(p.blurb || "Energized after your birth-chart reading.") +
      '</p><div class="pcard-price"><div data-save-deal data-deal-size="card" data-sale="' +
      p.sale +
      '" data-mrp="' +
      p.mrp +
      '"></div></div><div class="pcard-actions">' +
      (p.available === false
        ? '<p class="btn w-full cursor-not-allowed bg-maroon/20 text-maroon">Currently unavailable</p>'
        : '<a href="' + href +
          '" class="btn btn-primary w-full">View &amp; buy</a>') +
      '<a href="' +
      escapeHTML(wa) +
      '" target="_blank" rel="noopener noreferrer" class="pcard-wa"><svg viewBox="0 0 24 24" class="size-4" fill="currentColor" aria-hidden="true"><path d="M20.52 3.48A11.86 11.86 0 0 0 12.06 0C5.5 0 .16 5.34.16 11.9c0 2.1.55 4.14 1.6 5.95L0 24l6.3-1.65a11.86 11.86 0 0 0 5.76 1.47h.01c6.56 0 11.9-5.34 11.9-11.9 0-3.18-1.24-6.17-3.45-8.44Z"/></svg>Ask on WhatsApp</a></div></div></article>'
    );
  };

  function initHero() {
    const root = $("[data-hero]");
    if (!root) return;
    const slides = $$(".shop-hero-slide", root);
    const dots = $$("[data-hero-dot]", root);
    const live = $("[data-hero-live]", root);
    const productName = $('[data-hero-product]', root);
    const mobileName = $('[data-hero-mobile-name]', root);
    const productLink = $('[data-hero-product-link]', root);
    const heroNames = {
      'lalitha-kanak-chakra': 'Lalitha Kanak Chakra',
      'akshay-kuber-vajra': 'Akshay Kuber Vajra',
      'rajlaxmi-suvarna-yantra': 'Rajlaxmi Suvarna Yantra',
      'abhaya-kuber-vajra': 'Abhaya Kuber Vajra',
      'dhanakarshan': 'Dhan Aakarshan Mahayantra',
      'gruh-yantra': 'Mahalakshmi Gruh Mahayantra',
      'vishesh-manokamna-mahayantra': 'Vishesh Manokamna Mahayantra',
      'dhankumbh': 'Mahalakshmi Dhanakumbh Shri Yantra'
    };
    if (!slides.length) return;
    let i = 0;
    let paused = false;
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach((s, k) => {
        s.classList.toggle("is-on", k === i);
        s.tabIndex = k === i ? 0 : -1;
      });
      dots.forEach((d, k) => {
        d.setAttribute("aria-current", k === i ? "true" : "false");
        d.className = "h-1.5 rounded-full transition-all " + (k === i ? "w-6 bg-gold" : "w-1.5 bg-white/70");
      });
      const slideUrl = new URL(slides[i].getAttribute('href'), location.origin);
      const handle = slideUrl.pathname.split('/').filter(Boolean).pop() || '';
      const name = heroNames[handle] || (slides[i].getAttribute('aria-label') || '').split(',')[0];
      if (productName) productName.textContent = name;
      if (mobileName) mobileName.textContent = name;
      if (productLink) {
        const product = YA.getProduct(handle);
        productLink.href = product && product.url ? product.url : slides[i].href;
        productLink.setAttribute('aria-label', 'Discover ' + name);
      }
      if (live) live.textContent = slides[i].getAttribute("aria-label") || "";
    }
    const prev = $("[data-hero-prev]", root);
    const next = $("[data-hero-next]", root);
    if (prev) prev.addEventListener("click", function () { show(i - 1); });
    if (next) next.addEventListener("click", function () { show(i + 1); });
    dots.forEach((d, k) => d.addEventListener("click", function () { show(k); }));
    let x0 = null;
    root.addEventListener("touchstart", function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener("touchend", function (e) {
      if (x0 == null) return;
      const dx = e.changedTouches[0].clientX - x0;
      x0 = null;
      if (dx > 40) show(i - 1);
      if (dx < -40) show(i + 1);
    });
    root.addEventListener("mouseenter", function () { paused = true; });
    root.addEventListener("mouseleave", function () { paused = false; });
    root.addEventListener("keydown", function (e) {
      if (e.key === "ArrowLeft") show(i - 1);
      if (e.key === "ArrowRight") show(i + 1);
    });
    root.addEventListener('focusin', function () { paused = true; });
    root.addEventListener('focusout', function () { paused = false; });
    show(0);
    if (!reduced) {
      window.setInterval(function () {
        if (!paused) show(i + 1);
      }, 8200);
    }
  }

  function initMenu() {
    const drawer = $(".cat-drawer");
    if (!drawer) return;
    const openBtns = $$("[data-open-menu]");
    const MENU_ICO =
      '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-6" aria-hidden="true"><path d="M4 5h16"/><path d="M4 12h16"/><path d="M4 19h16"/></svg>';
    const CLOSE_ICO =
      '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" class="size-6" aria-hidden="true"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>';
    function isOpen() {
      return drawer.classList.contains("is-open");
    }
    function open() {
      drawer.hidden = false;
      drawer.classList.add("is-open");
      drawer.setAttribute("aria-hidden", "false");
      drawer.removeAttribute("inert");
      lockScroll(true);
      openBtns.forEach(function (b) {
        b.setAttribute("aria-expanded", "true");
        b.setAttribute("aria-label", "Close menu");
        if (b.querySelector("svg")) b.innerHTML = CLOSE_ICO;
      });
    }
    function close() {
      drawer.classList.remove("is-open");
      drawer.setAttribute("aria-hidden", "true");
      drawer.setAttribute("inert", "");
      lockScroll(false);
      openBtns.forEach(function (b) {
        b.setAttribute("aria-expanded", "false");
        b.setAttribute("aria-label", "Open categories");
        if (b.querySelector("svg")) b.innerHTML = MENU_ICO;
      });
      window.setTimeout(function () {
        if (!isOpen()) drawer.hidden = true;
      }, 240);
    }
    function toggle(e) {
      if (e) e.preventDefault();
      if (isOpen()) close();
      else open();
    }
    openBtns.forEach(function (b) {
      b.setAttribute("aria-expanded", "false");
      b.addEventListener("click", toggle);
    });
    $$("[data-close-menu]").forEach(function (b) {
      b.addEventListener("click", close);
    });
    drawer.addEventListener("click", function (e) {
      const a = e.target.closest("a[href]");
      if (!a) return;
      const href = a.getAttribute("href") || "";
      if (!isPageHref(href)) return;
      drawer.classList.remove("is-open");
      drawer.hidden = true;
      lockScroll(false);
    });
    window.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && isOpen()) close();
    });
  }

  function initSearch() {
    const el = $("[data-search]");
    if (!el) return;
    const input = $("[data-search-input]", el);
    const box = $("[data-search-results]", el);
    function close() {
      el.hidden = true;
      el.setAttribute("aria-hidden", "true");
      if (input) input.value = "";
      if (box) box.innerHTML = "";
      if (!anySheetOpen("search")) lockScroll(false);
    }
    function open() {
      openSheet("search");
      window.setTimeout(function () { if (input) input.focus(); }, 40);
    }
    function paint() {
      if (!box) return;
      const q = (input && input.value) || "";
      const rows = YA.searchProducts(q, 8);
      if (!q.trim()) {
        box.innerHTML = "";
        return;
      }
      if (!rows.length) {
        box.innerHTML = '<p class="px-5 py-8 text-center text-sm text-muted">No instruments match that search.</p>';
        return;
      }
      box.innerHTML =
        '<ul class="py-2">' +
        rows
          .map((p) => {
            const pct = YA.salePercent(p);
            return (
              '<li><a href="' +
              YA.productHref(p) +
              '" class="flex items-center gap-3 px-4 py-2.5 hover:bg-white"><img src="' +
              p.image +
              '" alt="" class="size-12 rounded-lg object-cover"><span class="min-w-0 flex-1"><span class="block truncate font-serif font-bold text-maroon">' +
              p.title +
              '</span><span class="mt-0.5 block font-clock text-xs tracking-wide text-maroon tabular-nums">' +
              YA.formatINR(pct > 0 ? p.sale : p.sale) +
              (pct > 0 ? ' <span class="text-muted line-through">' + YA.formatINR(p.mrp) + "</span>" : "") +
              "</span></span></a></li>"
            );
          })
          .join("") +
        "</ul>";
    }
    $$("[data-open-search]").forEach((b) => b.addEventListener("click", open));
    $$("[data-close-search]").forEach((b) => b.addEventListener("click", close));
    if (input) {
      input.addEventListener("input", paint);
      input.form &&
        input.form.addEventListener("submit", function (e) {
          e.preventDefault();
          const first = YA.searchProducts(input.value, 1)[0];
          if (first) location.href = YA.productHref(first);
        });
    }
    window.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !el.hidden) close();
    });
  }

  function mobileDigits(raw) {
    const d = String(raw || "").replace(/\D/g, "");
    return d.length > 10 ? d.slice(-10) : d;
  }
  function validMobile(raw) {
    return /^[6-9]\d{9}$/.test(mobileDigits(raw));
  }
  function maskPhone(phone) {
    const d = mobileDigits(phone);
    if (d.length < 10) return phone;
    return "+91 " + d.slice(0, 2) + "•• ••••" + d.slice(-2);
  }

  function initCoupon() {
    // In Shopify mode the coupon is a real, always-valid discount code, so the
    // old fake phone/OTP "unlock" step is skipped — the dialog opens straight
    // to the code. (The old OTP was generated in the browser; Shopify discounts
    // require server-side rules, so that flow can't be used to gate the code.)
    const el = $("[data-coupon]");
    if (!el) return;
    const phoneForm = $("[data-coupon-phone]", el);
    const otpForm = $("[data-coupon-otp]", el);
    const done = $("[data-coupon-done]", el);
    let phone = "";
    function session() {
      try {
        return JSON.parse(localStorage.getItem(COUPON_KEY) || "null");
      } catch (e) {
        return null;
      }
    }
    function show(step) {
      if (phoneForm) phoneForm.hidden = step !== "phone";
      if (otpForm) otpForm.hidden = step !== "otp";
      if (done) done.hidden = step !== "done";
      const word = $("[data-coupon-word]", el);
      const title = $("[data-coupon-title]", el);
      if (word) word.textContent = "GRACE";
      if (title) {
        title.textContent =
          step === "done" ? "You are received at the ashram" : "The ashram keeps a seat for this visit";
      }
    }
    function open() {
      openSheet("coupon");
      if (window.YA_SHOPIFY_MODE) { show("done"); return; }
      show(session() ? "done" : "phone");
      const input = phoneForm && phoneForm.querySelector("[name=phone]");
      if (input && !session()) setTimeout(function () { try { input.focus(); } catch (err) {} }, 40);
    }
    function close() {
      releaseSheet("coupon");
    }
    document.addEventListener("click", function (e) {
      if (!e.target.closest("[data-open-coupon]")) return;
      e.preventDefault();
      open();
    });
    el.addEventListener("click", function (e) {
      if (e.target.closest("[data-close-coupon], .coupon-x, .coupon-dim")) {
        e.preventDefault();
        close();
      }
    });
    if (session()) $$(".coupon-fab").forEach((b) => b.classList.add("is-in"));
    if (phoneForm) {
      const phoneInput = phoneForm.querySelector("[name=phone]");
      const submitPhone = phoneForm.querySelector("[data-coupon-submit-phone], button[type=submit]");
      if (submitPhone) {
        submitPhone.disabled = false;
        submitPhone.removeAttribute("disabled");
      }
      if (phoneInput) {
        phoneInput.setAttribute("maxlength", "13");
        function onPhoneEdit() {
          const d = mobileDigits(phoneInput.value);
          if (phoneInput.value !== d) phoneInput.value = d;
          if (d.length === 10 && YA.journey && YA.journey.capture) {
            YA.journey.capture({ phone: d, source: "ashram_grace", immediate: true });
          }
        }
        ["input", "change", "blur", "paste"].forEach(function (ev) {
          phoneInput.addEventListener(ev, function () { setTimeout(onPhoneEdit, 0); });
        });
      }
      phoneForm.addEventListener("submit", function (e) {
        e.preventDefault();
        const input = phoneForm.querySelector("[name=phone]");
        const err = $("[data-coupon-err-phone]", el);
        const d = mobileDigits((input && input.value) || "");
        if (input) input.value = d;
        if (!validMobile(d)) {
          if (err) err.textContent = "Enter a 10-digit Indian mobile starting with 6–9.";
          if (input) input.focus();
          return;
        }
        if (err) err.textContent = "";
        phone = d;
        const code = String(Math.floor(1000 + Math.random() * 9000));
        try {
          sessionStorage.setItem(OTP_KEY, JSON.stringify({ phone: d, code: code, exp: Date.now() + 5 * 60 * 1000 }));
        } catch (err2) {}
        const lead = $("[data-otp-lead]", el);
        const preview = $("[data-otp-preview]", el);
        if (lead) lead.innerHTML = "Sent to " + maskPhone(d) + ".";
        if (preview) preview.innerHTML = "Preview code · <b>" + code + "</b><span> Preview only until SMS is connected. Use this code to continue.</span>";
        show("otp");
        if (YA.journey) YA.journey.track("otp_requested", { source: "ashram_grace" });
        const first = $$("[data-otp-d]", el)[0];
        if (first) first.focus();
      });
    }
    const digits = $$("[data-otp-d]", el);
    const submitOtp = otpForm && otpForm.querySelector("[data-coupon-submit-otp], button[type=submit]");
    if (submitOtp) {
      submitOtp.disabled = false;
      submitOtp.removeAttribute("disabled");
    }
    digits.forEach((inp, i) => {
      inp.addEventListener("input", function () {
        inp.value = inp.value.replace(/\D/g, "").slice(-1);
        if (inp.value && digits[i + 1]) digits[i + 1].focus();
        if (i === 3 && digits.every((d) => d.value) && otpForm) {
          if (typeof otpForm.requestSubmit === "function") otpForm.requestSubmit();
          else otpForm.dispatchEvent(new Event("submit", { cancelable: true, bubbles: true }));
        }
      });
      inp.addEventListener("keydown", function (e) {
        if (e.key === "Backspace" && !inp.value && digits[i - 1]) digits[i - 1].focus();
      });
    });
    if (otpForm) {
      otpForm.addEventListener("submit", function (e) {
        e.preventDefault();
        const err = $("[data-coupon-err-otp]", el);
        const code = digits.map((d) => d.value).join("");
        if (code.length !== 4) {
          if (err) err.textContent = "Enter the 4-digit ashram code.";
          return;
        }
        try {
          const rec = JSON.parse(sessionStorage.getItem(OTP_KEY) || "null");
          if (!rec || rec.exp < Date.now()) {
            if (err) err.textContent = "Code expired. Close and request a new one.";
            return;
          }
          if (mobileDigits(rec.phone) !== mobileDigits(phone) || rec.code !== code) {
            if (err) err.textContent = "That code does not match. Try again.";
            return;
          }
          sessionStorage.removeItem(OTP_KEY);
          localStorage.setItem(COUPON_KEY, JSON.stringify({ phone: phone, at: Date.now(), coupon: COUPON_CODE }));
        } catch (err2) {
          if (err) err.textContent = "Could not verify. Please try again.";
          return;
        }
        YA.claimDeal();
        $$(".coupon-fab").forEach((b) => b.classList.add("is-in"));
        show("done");
        if (YA.journey) {
          YA.journey.stitch({ phone: phone, source: "ashram_grace" });
          YA.journey.track("otp_verified", { source: "ashram_grace" });
          YA.journey.track("coupon_grace", {});
        }
      });
    }
    window.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !el.hidden) close();
    });
  }

  function wantsKmm() {
    const hash = (location.hash || "").replace(/^#/, "").toLowerCase();
    if (hash === "kmm" || hash === "know-your-mahayantra" || hash === "know-my-mahayantra") return true;
    const q = new URLSearchParams(location.search);
    if (q.get("kmm") === "1" || q.get("form") === "kmm") return true;
    const path = (location.pathname || "/").replace(/\.html$/, "").replace(/\/$/, "") || "/";
    return path === "/kmm" || path === "/know-your-mahayantra" || path === "/know-my-mahayantra";
  }

  YA.openKnowMahayantra = function () {
    const el = openSheet("kmm");
    if (!el) return;
    try {
      sessionStorage.setItem("ya-kmm-seen", "1");
    } catch (e) {}
    if (YA.journey) YA.journey.track("kmm_opened", {});
    if (!wantsKmm()) {
      try {
        history.replaceState(history.state, "", "#kmm");
      } catch (err) {}
    }
  };

  function initKmm() {
    const el = $("[data-kmm]");
    if (!el) return;
    $$("[data-open-kmm], #open-kmm").forEach((b) =>
      b.addEventListener("click", function (e) {
        e.preventDefault();
        YA.openKnowMahayantra();
      })
    );
    document.addEventListener("click", function (e) {
      const a = e.target.closest(
        'a[href="#kmm"], a[href="/#kmm"], a[href="/kmm"], a[href="/know-your-mahayantra"], a[href="/know-my-mahayantra"]'
      );
      if (!a) return;
      e.preventDefault();
      YA.openKnowMahayantra();
    });
    $$("[data-close-kmm]", el).forEach((b) =>
      b.addEventListener("click", function () {
        releaseSheet("kmm");
        if (wantsKmm() && (location.hash || "").toLowerCase().indexOf("kmm") !== -1) {
          try {
            history.replaceState(history.state, "", location.pathname + location.search);
          } catch (err) {}
        }
      })
    );
    const form = el.querySelector("form");
    if (form) {
      form.addEventListener("input", function () {
        const payload = Object.fromEntries(new FormData(form).entries());
        if (YA.journey && YA.journey.capture) {
          YA.journey.capture({
            name: payload.name,
            phone: payload.phone,
            email: payload.email,
            city: payload.city,
            source: "kmm",
          });
        }
      });
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        const payload = Object.fromEntries(new FormData(form).entries());
        if (!payload.name || !payload.phone || !payload.dob) return;
        fetch("https://www.yogiadhiraajproducts.in/api/kmm.php", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload) }).catch(function () {});
        if (YA.journey) YA.journey.stitch({ phone: payload.phone, email: payload.email, name: payload.name, source: "kmm" });
        const extra = (function () {
          try {
            const q = JSON.parse(sessionStorage.getItem("ya-quiz") || "null");
            return q ? "\nQuiz seeking: " + (q.seeking || q.purpose || "") + "\nPlacement: " + (q.place || "") : "";
          } catch (err) {
            return "";
          }
        })();
        window.open(
          YA.waUrl(
            "सूक्ष्म जन्म विश्लेषण, Know My Mahayantra\nName: " +
              payload.name +
              "\nPhone: " +
              payload.phone +
              "\nEmail: " +
              (payload.email || "") +
              "\nCity: " +
              (payload.city || "") +
              "\nDate of birth: " +
              payload.dob +
              "\nTime of birth: " +
              (payload.tob || "not known") +
              "\nPlace of birth: " +
              (payload.pob || "not known") +
              "\nPurpose: " +
              (payload.seeking || "") +
              extra
          ),
          "_blank",
          "noopener,noreferrer"
        );
        releaseSheet("kmm");
      });
    }
    window.addEventListener("hashchange", function () {
      if (wantsKmm()) YA.openKnowMahayantra();
    });
    if (wantsKmm()) {
      window.setTimeout(function () {
        YA.openKnowMahayantra();
      }, 40);
    }
  }

  const GMARK =
    '<svg viewBox="0 0 24 24" class="size-5" aria-hidden><path fill="#4285F4" d="M23.5 12.3c0-.85-.08-1.67-.22-2.46H12v4.66h6.46a5.52 5.52 0 0 1-2.4 3.63v3h3.88c2.27-2.09 3.56-5.17 3.56-8.83Z"/><path fill="#34A853" d="M12 24c3.24 0 5.96-1.07 7.95-2.9l-3.88-3c-1.08.72-2.47 1.15-4.07 1.15-3.13 0-5.78-2.11-6.73-4.96H1.27v3.09A12 12 0 0 0 12 24Z"/><path fill="#FBBC05" d="M5.27 14.29A7.21 7.21 0 0 1 4.89 12c0-.8.14-1.57.38-2.29V6.62H1.27A12 12 0 0 0 0 12c0 1.94.46 3.77 1.27 5.38l4-3.09Z"/><path fill="#EA4335" d="M12 4.75c1.76 0 3.34.61 4.59 1.8l3.44-3.44C17.95 1.19 15.24 0 12 0 7.31 0 3.26 2.69 1.27 6.62l4 3.09C6.22 6.86 8.87 4.75 12 4.75Z"/></svg>';
  YA.googleMark = GMARK;
  const GBTN =
    "inline-flex min-h-12 w-full items-center justify-center gap-3 rounded-full border border-maroon/20 bg-white px-5 text-sm font-semibold text-ink shadow-sm transition hover:border-gold hover:shadow-md";

  function googleFormInner() {
    return (
      '<form class="mt-8 space-y-3" data-google-form novalidate>' +
      '<input name="email" required type="email" inputmode="email" class="ya-gfield" placeholder="Gmail address" autocomplete="email" aria-label="Gmail address">' +
      '<button class="' +
      GBTN +
      '" type="submit" data-google-continue>' +
      GMARK +
      "Continue with Google</button>" +
      '<p data-google-err hidden class="text-center text-xs font-semibold text-maroon"></p></form>'
    );
  }

  function googleSheetHtml() {
    return (
      '<div data-google-sheet hidden class="fixed inset-0 z-[80] flex items-center justify-center px-4">' +
      '<button type="button" class="absolute inset-0 z-0 bg-black/65" data-close-google aria-label="Close"></button>' +
      '<div data-google-card class="relative z-10 w-full max-w-md rounded-3xl border border-gold/35 bg-white p-8 shadow-[0_24px_60px_#7a1e1e14]">' +
      '<button type="button" class="absolute top-3 right-3 z-10 grid size-10 place-items-center" data-close-google aria-label="Close">✕</button>' +
      '<div class="flex flex-col items-center text-center">' +
      '<img src="https://cdn.shopify.com/s/files/1/0732/8471/4662/files/images-logo-mark.webp" width="72" height="72" alt="">' +
      '<p class="mt-5 text-[11px] font-semibold tracking-[0.32em] text-gold-soft uppercase">Yogi Adhiraaj Sansthaanam</p>' +
      '<h2 class="mt-2 font-serif text-3xl font-bold text-maroon">Sign in</h2>' +
      '<p class="mt-3 max-w-sm text-sm leading-relaxed text-muted">One Google account is enough. The ashram keeps your Gmail so checkout fills itself, and so a Free Vishleshan may be offered with Dhan Aakarshan Mahayantra.</p></div>' +
      googleFormInner() +
      '<p class="mt-6 text-center text-xs leading-relaxed text-muted">We do not post on your behalf. On first sign-in the ashram desk receives your Gmail. About two hours later you may receive one letter offering a Free Vishleshan. Read the <a href="/privacy-policy" class="text-maroon underline decoration-gold underline-offset-2">Privacy Policy</a>.</p></div></div>'
    );
  }

  function nameFromEmail(email, typed) {
    const given = String(typed || "").trim();
    if (given) return given;
    const local = String(email || "")
      .split("@")[0]
      .replace(/[._+-]+/g, " ")
      .trim();
    return local.replace(/\b\w/g, function (c) {
      return c.toUpperCase();
    });
  }

  function googleUser() {
    try {
      return JSON.parse(localStorage.getItem(GOOGLE_KEY) || "null");
    } catch (e) {
      return null;
    }
  }

  function saveGoogleUser(email, name) {
    const rec = { email: email, name: nameFromEmail(email, name), photo: "" };
    try {
      localStorage.setItem(GOOGLE_KEY, JSON.stringify(rec));
      localStorage.setItem(KNOWN_KEY, "1");
    } catch (err) {}
    fetch("https://www.yogiadhiraajproducts.in/api/lead.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(rec),
    }).catch(function () {});
    return rec;
  }

  function readGoogleEmail(form) {
    if (!form) return "";
    try {
      const fd = new FormData(form);
      const fromData = String(fd.get("email") || "").trim();
      if (fromData) return fromData;
    } catch (e) {}
    const input = form.querySelector('input[name="email"], input[type="email"]');
    if (input && String(input.value || "").trim()) return String(input.value).trim();
    const named = form.elements && form.elements.namedItem ? form.elements.namedItem("email") : null;
    if (named && !named.length && named.value) return String(named.value).trim();
    if (named && named[0] && named[0].value) return String(named[0].value).trim();
    return "";
  }

  function showGoogleErr(form, msg) {
    if (!form) return;
    let err = form.querySelector("[data-google-err]");
    if (!err) {
      err = document.createElement("p");
      err.setAttribute("data-google-err", "");
      err.className = "text-center text-xs font-semibold text-maroon";
      form.appendChild(err);
    }
    err.textContent = msg || "";
    if (msg) err.removeAttribute("hidden");
    else err.setAttribute("hidden", "");
    err.hidden = !msg;
    const input = form.querySelector('input[name="email"], input[type="email"]');
    if (input) {
      input.setAttribute("aria-invalid", msg ? "true" : "false");
      if (msg) input.focus();
    }
  }

  function paintGoogle() {
    const u = googleUser();
    $$("[data-auth-slot]").forEach(function (slot) {
      if (!u) return;
      slot.outerHTML =
        '<a href="/login" class="ya-signin-btn is-in" aria-label="' +
        (u.name || u.email || "Account") +
        '">' +
        (u.photo
          ? '<img src="' + u.photo + '" alt="" class="ya-signin-face">'
          : '<span class="ya-signin-initial">' + String(u.name || u.email || "A").charAt(0).toUpperCase() + "</span>") +
        "</a>";
    });
    if (!u) return;
    $$("[data-google-open]").forEach(function (btn) {
      if (!btn.closest("[data-google-sheet]")) btn.hidden = true;
    });
    $$('input[type="email"], input[name="email"]').forEach(function (i) {
      if (i.closest("[data-google-sheet], [data-google-form]")) return;
      if (!i.value) {
        i.value = u.email;
        i.dispatchEvent(new Event("input", { bubbles: true }));
      }
    });
    if (u.name) {
      $$('input[name="name"], input[autocomplete="name"]').forEach(function (i) {
        if (i.closest("[data-google-sheet], [data-google-form]")) return;
        if (!i.value) {
          i.value = u.name;
          i.dispatchEvent(new Event("input", { bubbles: true }));
        }
      });
    }
    const loginMount = $("[data-login-auth]");
    if (loginMount) {
      loginMount.innerHTML =
        '<div class="flex flex-col items-center gap-4"><p class="text-sm text-muted">You are already signed in.</p>' +
        '<p class="font-semibold text-maroon">' +
        (u.name || u.email) +
        "</p>" +
        '<a href="/" class="text-sm font-semibold text-maroon underline decoration-gold underline-offset-4">Return to the ashram</a></div>';
    }
  }

  function completeGoogle(form, after) {
    if (!form || form.dataset.yaGoogleBusy) return false;
    const email = readGoogleEmail(form);
    const nameEl = form.querySelector('input[name="name"]');
    const name = nameEl ? String(nameEl.value || "").trim() : "";
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      showGoogleErr(form, "Enter your Gmail address to continue.");
      return false;
    }
    showGoogleErr(form, "");
    form.dataset.yaGoogleBusy = "1";
    const btn = form.querySelector("[data-google-continue], button[type='submit']");
    if (btn) {
      btn.disabled = true;
      btn.setAttribute("aria-busy", "true");
      btn.childNodes.forEach(function (n) {
        if (n.nodeType === 3) n.textContent = " Signing in…";
      });
    }
    saveGoogleUser(email, name);
    if (YA.journey) YA.journey.stitch({ email: email, name: name, source: "google" });
    paintGoogle();
    if (typeof after === "function") after();
    window.setTimeout(function () {
      location.reload();
    }, 220);
    return true;
  }

  function bindGoogleForm(form, after) {
    if (!form || form.dataset.yaGoogleBound) return;
    form.dataset.yaGoogleBound = "1";
    form.setAttribute("novalidate", "");
    if (!form.querySelector("[data-google-err]")) {
      form.insertAdjacentHTML(
        "beforeend",
        '<p data-google-err hidden class="text-center text-xs font-semibold text-maroon"></p>'
      );
    }
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      e.stopPropagation();
      completeGoogle(form, after);
    });
    const btn = form.querySelector("[data-google-continue], button[type='submit'], button");
    if (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        completeGoogle(form, after);
      });
    }
  }

  function hardenGoogleSheet(sheet) {
    if (!sheet) return;
    sheet.style.zIndex = "80";
    const dim = sheet.querySelector(":scope > [data-close-google]");
    if (dim) dim.style.zIndex = "0";
    let card = sheet.querySelector("[data-google-card]");
    if (!card && dim) card = dim.nextElementSibling;
    if (card) {
      card.setAttribute("data-google-card", "");
      card.style.position = "relative";
      card.style.zIndex = "10";
    }
  }

  function openGoogleSheet() {
    const sheet = openSheet("google");
    if (!sheet) return;
    hardenGoogleSheet(sheet);
    const em = sheet.querySelector('input[name="email"], input[type="email"]');
    if (em) window.setTimeout(function () { em.focus(); }, 40);
  }

  function closeGoogleSheet() {
    releaseSheet("google");
  }

  function initGoogle() {
    if (window.YA_SHOPIFY_MODE) {
      document.addEventListener('click', function (event) {
        const button = event.target.closest('[data-auth-slot],[data-google-open],.ya-signin-btn');
        if (!button) return;
        event.preventDefault();
        location.href = '/account/login';
      });
      return;
    }
    if (!$("[data-google-sheet]")) {
      document.body.insertAdjacentHTML("beforeend", googleSheetHtml());
    }
    $$("button").forEach(function (btn) {
      const t = (btn.textContent || "").replace(/\s+/g, " ").trim();
      if (t === "Use Google — email fills itself" || t === "Google से जारी रखें") {
        btn.setAttribute("data-google-open", "");
      }
    });
    paintGoogle();
    const sheet = $("[data-google-sheet]");
    hardenGoogleSheet(sheet);
    document.addEventListener("click", function (e) {
      const btn = e.target.closest("[data-auth-slot], [data-google-open], .ya-signin-btn");
      if (!btn) return;
      if (btn.closest("[data-google-form], [data-login-auth], [data-google-card]")) return;
      if (googleUser() && (btn.matches("[data-auth-slot], .ya-signin-btn") || btn.closest(".ya-signin-btn"))) {
        location.href = "/login";
        return;
      }
      e.preventDefault();
      openGoogleSheet();
    });
    if (sheet) {
      sheet.addEventListener("click", function (e) {
        if (e.target.closest("[data-google-card]") && !e.target.closest("[data-close-google]")) return;
        if (e.target.closest("[data-close-google]") || e.target === sheet) closeGoogleSheet();
      });
      bindGoogleForm(sheet.querySelector("[data-google-form], form"), function () {
        closeGoogleSheet();
      });
    }
    $$("[data-google-form]").forEach(function (form) {
      bindGoogleForm(form, function () {
        if (form.closest("[data-google-sheet]")) closeGoogleSheet();
      });
    });
  }

  function initHold() {
    const el = $("[data-hold]");
    if (!el) return;
    const quiet = ["/login", "/pages/contact", "/success", "/thank-you", "/order-confirmation"].some(
      (p) => location.pathname === p || location.pathname.indexOf(p + "/") === 0
    );
    if (quiet) return;
    function dismissed() {
      try {
        return sessionStorage.getItem("ya-hold-dismiss") === "1";
      } catch (e) {
        return false;
      }
    }
    function skip() {
      try {
        return Number(sessionStorage.getItem("ya-hold-skip") || 0) > Date.now();
      } catch (e) {
        return false;
      }
    }
    function show() {
      if (dismissed() || skip()) return;
      if (anySheetOpen("hold")) return;
      const paying = location.pathname.indexOf("/order-form") === 0;
      const title = paying ? "The offering is still at the fire" : "The courtyard remembered you";
      const body = paying
        ? "UPI is not complete. Do not pay twice. Return to this page, or write to the ashram. We will match the credit to your name."
        : "You stepped away. The Mahayantra did not. Forty-six golden years wait at Abhimatya Shikhar. Sit a moment, or let the ashram hold your sankalpa.";
      const tEl = $("#ya-hold-title", el);
      const pEl = $("[data-hold-body]", el);
      if (tEl) tEl.textContent = title;
      if (pEl) pEl.textContent = body;
      openSheet("hold");
    }
    $$("[data-hold-stay]", el).forEach((b) =>
      b.addEventListener("click", function () {
        try {
          sessionStorage.setItem("ya-hold-dismiss", "1");
          localStorage.removeItem("ya-come-back");
        } catch (e) {}
        releaseSheet("hold");
      })
    );
    const wa = $("[data-hold-wa]", el);
    if (wa) {
      wa.addEventListener("click", function () {
        try {
          sessionStorage.setItem("ya-hold-skip", String(Date.now() + 20000));
          localStorage.removeItem("ya-come-back");
        } catch (e) {}
        releaseSheet("hold");
        const paying = location.pathname.indexOf("/order-form") === 0;
        window.open(
          YA.waUrl(
            paying
              ? "Namaskaram. I was completing UPI for a Mahayantra and left the page. Please help me finish the order."
              : "Namaskaram. I was on yogiadhiraaj.com and had to leave. Please keep my place for a Mahayantra."
          ),
          "_blank",
          "noopener,noreferrer"
        );
      });
    }
  }

  function initAccordions() {
    $$("[data-acc]").forEach((root) => {
      $$("[data-acc-btn]", root).forEach((btn) => {
        btn.addEventListener("click", function () {
          const on = btn.getAttribute("aria-expanded") === "true";
          $$("[data-acc-btn]", root).forEach((b) => b.setAttribute("aria-expanded", "false"));
          $$("[data-acc-panel]", root).forEach((p) => {
            p.hidden = true;
          });
          $$("[data-acc-icon]", root).forEach((ic) => {
            ic.textContent = "+";
          });
          $$("[data-acc-btn] svg", root).forEach((svg) => {
            svg.style.transform = "";
            svg.classList.remove("rotate-180");
          });
          if (!on) {
            btn.setAttribute("aria-expanded", "true");
            const panel = btn.parentElement.querySelector("[data-acc-panel]");
            if (panel) panel.hidden = false;
            const icon = btn.querySelector("[data-acc-icon]");
            if (icon) icon.textContent = "-";
            const chev = btn.querySelector("svg");
            if (chev) {
              chev.style.transform = "rotate(180deg)";
              chev.classList.add("rotate-180");
            }
          }
        });
      });
    });
  }

  function initQuiz() {
    const root = $("#yogi-quiz");
    if (!root) return;
    root.style.scrollMarginTop = "6.75rem";
    const seeking = [
      { id: "financial", label: "Wealth and abundance", copy: "Dhan-Yog", seal: "https://cdn.shopify.com/s/files/1/0732/8471/4662/files/images-seals-wealth.webp" },
      { id: "family", label: "Peace in the home", copy: "Gruh Shanti", seal: "https://cdn.shopify.com/s/files/1/0732/8471/4662/files/images-seals-home.webp" },
      { id: "relationship", label: "Love and relationships", copy: "Prem-Bandh", seal: "https://cdn.shopify.com/s/files/1/0732/8471/4662/files/images-seals-love.webp" },
      { id: "wish", label: "One specific wish", copy: "Sankalp", seal: "https://cdn.shopify.com/s/files/1/0732/8471/4662/files/images-seals-wish.webp" },
      { id: "child", label: "Help for a child", copy: "Bal Kalyan", seal: "https://cdn.shopify.com/s/files/1/0732/8471/4662/files/images-seals-child.webp" },
    ];
    const place = [
      { id: "home", label: "Home temple / puja room" },
      { id: "office", label: "Office, shop or cabin" },
      { id: "wear", label: "Wear or carry with me" },
    ];
    let step = 0;
    let seek = "";
    let where = "";
    const mount = $("[data-quiz-mount]", root);
    const qlabel = $("[data-quiz-q]", root);
    if (!mount) return;

    YA.jumpQuiz = function () {
      closeSheet("hold");
      if (!anySheetOpen()) lockScroll(false);
      const header = $("header");
      const offset = (header ? header.getBoundingClientRect().height : 96) + 10;
      const top = root.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
      try {
        history.replaceState(history.state, "", "#yogi-quiz");
      } catch (err) {}
    };

    document.addEventListener("click", function (e) {
      const a = e.target.closest('a[href="#yogi-quiz"], a[href="/#yogi-quiz"]');
      if (!a) return;
      e.preventDefault();
      YA.jumpQuiz();
    });

    function recs(purpose) {
      const pool = (YA.productsIn ? YA.productsIn("all", purpose) : []).filter((p) => p.available !== false);
      const singles = pool.filter((p) => !p.bundle && !(p.title || "").includes("+"));
      return (singles.length >= 3 ? singles : pool).slice(0, 3);
    }
    function render() {
      if (qlabel) {
        qlabel.className =
          step < 3
            ? "mt-4 text-xs font-bold uppercase tracking-[0.18em] text-maroon/70"
            : "mt-4 text-xs font-bold uppercase tracking-[0.18em] text-gold-soft";
        qlabel.textContent = step < 3 ? "Question " + (step + 1) + " of 3" : "Your matching instruments";
      }
      if (step === 0) {
        mount.innerHTML =
          '<div class="mt-4 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">' +
          seeking
            .map(
              (s) =>
                '<button type="button" class="flex min-h-14 items-center gap-3 rounded-2xl border border-maroon/10 bg-cream px-4 py-3 text-left transition hover:border-gold hover:shadow-md active:scale-[0.98]" data-seek="' +
                s.id +
                '"><span class="photo-seal photo-seal-sm shrink-0"><img src="' +
                s.seal +
                '" alt="" width="56" height="56"></span><span class="min-w-0"><span class="block text-[10px] font-bold uppercase tracking-[0.18em] text-gold-soft">' +
                s.copy +
                '</span><span class="mt-1 block font-serif text-lg font-bold text-maroon">' +
                s.label +
                "</span></span></button>"
            )
            .join("") +
          "</div>";
      } else if (step === 1) {
        mount.innerHTML =
          '<div class="mt-4 grid gap-3 sm:grid-cols-3">' +
          place
            .map(
              (s) =>
                '<button type="button" class="min-h-16 rounded-2xl border border-maroon/10 bg-cream px-5 py-4 text-left font-serif text-lg font-bold text-maroon transition hover:border-gold hover:shadow-md active:scale-[0.98]" data-place="' +
                s.id +
                '">' +
                s.label +
                "</button>"
            )
            .join("") +
          "</div>";
      } else if (step === 2) {
        mount.innerHTML =
          '<div class="mt-4 grid gap-3 sm:grid-cols-2">' +
          '<button type="button" class="min-h-20 rounded-2xl border border-maroon/10 bg-cream px-5 py-5 text-left transition hover:border-gold active:scale-[0.98]" data-quiz-go>' +
          '<span class="font-serif text-lg font-bold text-maroon">Show matching instruments</span>' +
          '<span class="mt-1 block text-sm text-muted">Browse what seekers in this purpose usually begin with.</span></button>' +
          '<button type="button" class="min-h-20 rounded-2xl bg-maroon px-5 py-5 text-left text-cream transition hover:bg-maroon-deep active:scale-[0.98]" data-quiz-kmm>' +
          '<span class="font-serif text-lg font-bold">Personal birth-chart reading</span>' +
          '<span class="mt-1 block text-sm text-cream/80">Share name and birth details. An advisor replies on WhatsApp.</span></button></div>';
      } else {
        const picks = recs(seek);
        mount.innerHTML =
          '<div class="mt-6"><div class="grid gap-4 sm:grid-cols-3">' +
          picks
            .map(function (p) {
              return (
                '<article class="card-lift overflow-hidden rounded-2xl border border-maroon/10 bg-cream"><a href="' +
                YA.productHref(p) +
                '"><img src="' +
                (p.image || "") +
                '" alt="" class="aspect-square w-full object-cover"><div class="px-4 pt-4"><p class="font-serif font-bold text-maroon">' +
                p.title +
                '</p></div></a><div class="p-4 pt-2"><span class="font-clock tracking-wide text-maroon tabular-nums">' +
                YA.formatINR(p.sale) +
                "</span></div></article>"
              );
            })
            .join("") +
          '</div><div class="mt-6 flex flex-col gap-3 sm:flex-row">' +
          '<button type="button" class="btn btn-gold min-h-12" data-open-kmm>Know Your Mahayantra</button>' +
          '<a class="btn btn-primary min-h-12" href="/pages/products?purpose=' +
          encodeURIComponent(seek) +
          '">View all in this purpose</a>' +
          '<button type="button" class="min-h-12 rounded-full border border-maroon/20 px-6 font-semibold text-maroon" data-quiz-reset>Start over</button></div></div>';
      }
    }
    function saveQuiz() {
      try {
        sessionStorage.setItem(
          "ya-quiz",
          JSON.stringify({
            purpose: seek,
            place: where,
            seeking: (seeking.find((x) => x.id === seek) || {}).label,
            savedAt: new Date().toISOString(),
          })
        );
      } catch (err) {}
      if (YA.journey) YA.journey.track("recommendation_completed", { intent: seek, place: where });
    }
    root.addEventListener("click", function (e) {
      const s = e.target.closest("[data-seek]");
      if (s) {
        seek = s.getAttribute("data-seek");
        step = 1;
        render();
        return;
      }
      const p = e.target.closest("[data-place]");
      if (p) {
        where = p.getAttribute("data-place");
        step = 2;
        render();
        return;
      }
      if (e.target.closest("[data-quiz-go]")) {
        saveQuiz();
        step = 3;
        render();
        return;
      }
      if (e.target.closest("[data-quiz-kmm]")) {
        saveQuiz();
        step = 3;
        render();
        YA.openKnowMahayantra();
        return;
      }
      if (e.target.closest("[data-quiz-reset]")) {
        step = 0;
        seek = "";
        where = "";
        render();
        return;
      }
      if (e.target.closest("[data-open-kmm]")) YA.openKnowMahayantra();
    });
    render();
    if (location.hash === "#yogi-quiz") {
      window.setTimeout(function () {
        YA.jumpQuiz();
      }, 60);
    }
  }

  function initShop() {
    const grid = $("[data-shop-grid]");
    if (!grid || !YA.PRODUCTS) return;
    const PAGE = 9;
    const params = new URLSearchParams(location.search);
    let category = params.get("category") || grid.getAttribute("data-default-cat") || "yantras";
    let purpose = params.get("purpose") || "all";
    let sort = params.get("sort") || "newest";
    let q = "";
    let shown = PAGE;
    const countEl = $("[data-shop-count]");
    function list() {
      let rows = YA.sortProducts(YA.productsIn(category, purpose), sort);
      const needle = q.trim().toLowerCase();
      if (needle) {
        rows = rows.filter(
          (p) =>
            p.title.toLowerCase().includes(needle) ||
            (p.subtitle || "").toLowerCase().includes(needle) ||
            (p.ribbon || "").toLowerCase().includes(needle)
        );
      }
      return rows;
    }
    function paint() {
      const rows = list();
      const vis = rows.slice(0, shown);
      grid.innerHTML = vis.map((p, i) => YA.cardHtml(p, i < 4)).join("") || '<p class="py-16 text-center text-muted">No instruments match that search.</p>';
      if (countEl) countEl.textContent = "Showing " + vis.length + " of " + rows.length + " instruments";
      const more = $("[data-shop-more]");
      if (more) more.hidden = shown >= rows.length;
      paintPrices();
      $$("[data-cat-pill]").forEach((el) => {
        const slug = el.getAttribute("data-cat-pill");
        const match =
          (slug === "all" && String(category).toLowerCase() === "all") ||
          (slug !== "all" && YA.categoryKey(category) === YA.categoryKey(slug) && String(category).toLowerCase() !== "all");
        el.className = "cat-pill " + (match ? "cat-pill-on" : "cat-pill-off");
      });
      $$("[data-purpose-pill]").forEach((el) => {
        const on = el.getAttribute("data-purpose-pill") === purpose;
        el.className =
          "shrink-0 rounded-full border px-3 py-2 text-[11px] font-bold tracking-wide uppercase " +
          (on ? "border-maroon bg-maroon text-gold" : "border-maroon/15 bg-white text-maroon hover:border-gold");
      });
    }
    $$("[data-cat-pill]").forEach((el) => {
      el.addEventListener("click", function (e) {
        e.preventDefault();
        category = el.getAttribute("data-cat-pill") || "all";
        shown = PAGE;
        const u = new URL(location.href);
        u.searchParams.set("category", category);
        history.replaceState({}, "", u);
        paint();
      });
    });
    $$("[data-purpose-pill]").forEach((el) => {
      el.addEventListener("click", function (e) {
        e.preventDefault();
        purpose = el.getAttribute("data-purpose-pill") || "all";
        if (purpose !== "all") category = "all";
        shown = PAGE;
        const u = new URL(location.href);
        u.searchParams.set("purpose", purpose);
        u.searchParams.set("category", category);
        history.replaceState({}, "", u);
        paint();
      });
    });
    const search = $("[data-shop-q]");
    if (search) {
      search.addEventListener("input", function () {
        q = search.value;
        shown = PAGE;
        paint();
      });
    }
    const sel = $("[data-shop-sort]");
    if (sel) {
      sel.value = sort;
      sel.addEventListener("change", function () {
        sort = sel.value;
        shown = PAGE;
        const u = new URL(location.href);
        u.searchParams.set("sort", sort);
        history.replaceState({}, "", u);
        paint();
      });
    }
    const more = $("[data-shop-more]");
    if (more) {
      more.addEventListener("click", function () {
        shown += PAGE;
        paint();
      });
    }
    paint();
  }

  function initFind() {
    const root = $("[data-find]");
    if (!root) return;
    if (!YA.FIND_PURPOSES || !YA.FIND_PURPOSES.length) {
      window.setTimeout(initFind, 60);
      return;
    }
    if (root.getAttribute("data-find-ready")) return;
    root.setAttribute("data-find-ready", "1");
    const params = new URLSearchParams(location.search);
    let picked = params.get("purpose") || "";
    if (picked && YA.journey) YA.journey.track("intent_selected", { intent: picked, from: "guide" });
    const mount = $("[data-find-mount]", root) || root;
    const seals = { financial: "wealth", business: "business", family: "home", relationship: "love", protection: "protect", wish: "wish", child: "child" };
    const chev = '<span class="finder-go" aria-hidden="true"><svg class="size-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8"><path d="m9 18 6-6-6-6"/></svg></span>';
    const waIcon = '<svg viewBox="0 0 24 24" class="size-4" fill="currentColor" aria-hidden="true"><path d="M20.52 3.48A11.86 11.86 0 0 0 12.06 0C5.5 0 .16 5.34.16 11.9c0 2.1.55 4.14 1.6 5.95L0 24l6.3-1.65a11.86 11.86 0 0 0 5.76 1.47h.01c6.56 0 11.9-5.34 11.9-11.9 0-3.18-1.24-6.17-3.45-8.44Z"/></svg>';
    function recs(id) {
      const intent = (YA.FIND_PURPOSES || []).find((p) => p.id === id);
      const all = (YA.PRODUCTS || []).filter((p) => p.available !== false);
      if (!intent) return all.slice(0, 6);
      const pinned = (intent.pinIds || []).map(YA.getProduct).filter((p) => p && p.available !== false);
      const rest = YA.productsIn("all", intent.catalogPurpose).filter((p) => p.available !== false && !(intent.pinIds || []).includes(p.id));
      const out = [];
      const seen = new Set();
      pinned.concat(rest).forEach((p) => {
        if (!p || seen.has(p.id)) return;
        seen.add(p.id);
        out.push(p);
      });
      return (out.length ? out : all).slice(0, 6);
    }
    function paint() {
      const step2 = Boolean(picked);
      const back = '<button type="button" class="grid size-11 place-items-center rounded-full text-maroon hover:bg-maroon/5" data-find-back aria-label="Back"><svg class="size-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="m12 19-7-7 7-7"/><path d="M19 12H5"/></svg></button>';
      const track =
        '<ol class="finder-track" aria-label="Guide steps"><li class="is-on"><span>1</span>Purpose</li><li class="' +
        (step2 ? "is-on" : "") +
        '"><span>2</span>Products</li><li><span>3</span>Review</li></ol>';
      const bar = '<div class="mb-4 flex items-center gap-2">' + back + track + "</div>";
      if (!picked) {
        mount.innerHTML =
          bar +
          '<h1 class="mt-6 text-center font-serif text-[1.85rem] font-bold text-maroon sm:text-3xl">What are you looking for?</h1>' +
          '<p class="mx-auto mt-2 max-w-sm text-center text-sm leading-relaxed text-muted">Choose your purpose and we will show you the most suitable Yantras.</p>' +
          '<div class="gold-rule"></div><ul class="mt-6 space-y-2.5">' +
          YA.FIND_PURPOSES.map(
            (p) =>
              '<li><a class="finder-row" href="/pages/find?purpose=' +
              p.id +
              '" data-find-pick="' +
              p.id +
              '"><span class="photo-seal photo-seal-sm"><img src="https://www.yogiadhiraajproducts.in/images/seals/' +
              (seals[p.id] || "wish") +
              '.webp" alt="' +
              p.label +
              '" width="256" height="256" decoding="async" loading="lazy"></span><span class="min-w-0 flex-1 text-left"><span class="block font-serif text-lg font-bold text-maroon">' +
              p.label +
              '</span><span class="mt-0.5 block text-sm leading-snug text-muted">' +
              p.hint +
              "</span></span>" +
              chev +
              "</a></li>"
          ).join("") +
          '</ul><p class="mt-4 text-center text-sm"><a href="' +
          YA.waUrl("I am not sure which yantra is right for me. Please guide me.") +
          '" target="_blank" rel="noopener noreferrer" class="inline-flex items-center gap-1.5 font-semibold text-maroon">' +
          waIcon +
          "Talk to us on WhatsApp</a></p>";
        return;
      }
      const intent = YA.FIND_PURPOSES.find((p) => p.id === picked);
      const rows = recs(picked);
      mount.innerHTML =
        bar +
        '<h1 class="mt-4 text-center font-serif text-[1.85rem] font-bold text-maroon sm:text-3xl">' +
        (intent ? intent.label : "Instruments") +
        '</h1><p class="mx-auto mt-2 max-w-sm text-center text-sm leading-relaxed text-muted">' +
        rows.length +
        " yantras matched to this purpose. Tap a row to open it.</p>" +
        '<div class="gold-rule"></div><ul class="mt-6 space-y-3">' +
        rows
          .map((p) => {
            const pct = YA.salePercent(p);
            const href = pct > 0 ? YA.productHref(p) + "?claim=1" : YA.productHref(p);
            return (
              '<li><a href="' +
              href +
              '" class="finder-product"><img src="' +
              p.image +
              '" alt="" width="80" height="80" class="size-20 shrink-0 rounded-lg object-cover"><span class="min-w-0 flex-1 text-left"><span class="block font-serif text-base font-bold leading-snug text-maroon">' +
              p.title +
              '</span><span class="finder-price font-clock tracking-wide text-maroon tabular-nums"><b class="font-normal">' +
              YA.formatINR(p.mrp) +
              "</b>" +
              (pct > 0 ? '<span class="finder-save">Save ' + pct + "%</span>" : "") +
              "</span></span>" +
              chev +
              "</a></li>"
            );
          })
          .join("") +
        '</ul><a href="' +
        YA.waUrl("I need help choosing a yantra for " + ((intent && intent.label) || "my purpose") + ".") +
        '" target="_blank" rel="noopener noreferrer" class="mt-5 flex min-h-12 items-center justify-center gap-2 rounded-full border-2 border-maroon bg-white text-sm font-bold text-maroon">' +
        waIcon.replace("size-4", "size-5") +
        "Need help choosing?</a>";
    }
    root.addEventListener("click", function (e) {
      const pick = e.target.closest("[data-find-pick]");
      if (pick) {
        e.preventDefault();
        picked = pick.getAttribute("data-find-pick");
        const u = new URL(location.href);
        u.searchParams.set("purpose", picked);
        history.pushState({}, "", u);
        paint();
        window.scrollTo(0, 0);
        if (YA.journey) YA.journey.track("intent_selected", { intent: picked, from: "guide" });
        return;
      }
      if (e.target.closest("[data-find-back]")) {
        e.preventDefault();
        if (picked) {
          picked = "";
          const u = new URL(location.href);
          u.searchParams.delete("purpose");
          history.pushState({}, "", u);
          paint();
        } else {
          location.href = "/";
        }
      }
    });
    window.addEventListener("popstate", function () {
      picked = new URLSearchParams(location.search).get("purpose") || "";
      paint();
    });
    paint();
  }

  function initContact() {
    const form = $("[data-contact-form]");
    if (!form) return;
    form.addEventListener("input", function () {
      const payload = Object.fromEntries(new FormData(form).entries());
      if (YA.journey && YA.journey.capture) {
        YA.journey.capture({
          name: payload.name,
          phone: payload.phone,
          email: payload.email,
          city: payload.city,
          source: "contact",
        });
      }
    });
    form.addEventListener("submit", async function (e) {
      e.preventDefault();
      const status = $("[data-contact-status]", form.parentElement) || $("[data-contact-status]");
      const btn = form.querySelector("[type=submit]");
      const payload = Object.fromEntries(new FormData(form).entries());
      if (btn) btn.disabled = true;
      try {
        const res = await fetch("https://www.yogiadhiraajproducts.in/api/contact.php", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });
        const json = await res.json();
        if (!json.ok) throw new Error(json.error || "fail");
        form.hidden = true;
        if (status) {
          status.hidden = false;
          status.textContent = "Namaskaram. Your note is with the ashram desk. We will write back on email or WhatsApp.";
        }
      } catch (err) {
        if (status) {
          status.hidden = false;
          status.textContent = "Could not send just now. Write to us on WhatsApp or try again.";
        }
      }
      if (btn) btn.disabled = false;
    });
  }

  function initSubscribe() {
    $$("[data-news-form]").forEach((form) => {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        const email = (form.querySelector("[name=email]") || {}).value || "";
        if (!email) return;
        fetch("https://www.yogiadhiraajproducts.in/api/subscribe.php", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email: email }),
        }).catch(function () {});
        try {
          localStorage.setItem("ya-newsletter", JSON.stringify({ email: email, at: new Date().toISOString() }));
        } catch (err) {}
        window.open(YA.waUrl("Ashram notes, subscribe for updates\nEmail: " + email), "_blank", "noopener,noreferrer");
        const note = form.parentElement.querySelector("[data-news-note]");
        if (note) note.textContent = "WhatsApp is opening with your request.";
        form.reset();
      });
    });
  }

  function initProduct() {
    const root = $("[data-pdp]");
    if (!root) return;
    const slug = root.getAttribute("data-slug") || "";
    if (YA.journey && slug) {
      YA.journey.track("view_item", { item_id: slug });
      if (YA.journey.remember) YA.journey.remember(slug);
    }
    const imgs = (root.getAttribute("data-images") || "").split("|").filter(Boolean);
    let i = 0;
    const main = $("[data-pdp-main]", root);
    const thumbs = $$("[data-pdp-thumb]", root);
    function show(n) {
      if (!imgs.length) return;
      i = (n + imgs.length) % imgs.length;
      if (main) main.src = imgs[i];
      thumbs.forEach((t, k) => t.classList.toggle("border-maroon", k === i));
      thumbs.forEach((t, k) => t.classList.toggle("border-transparent", k !== i));
    }
    thumbs.forEach((t, k) => t.addEventListener("click", function () { show(k); }));
    let x0 = null;
    if (main) {
      main.addEventListener("touchstart", function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      main.addEventListener("touchend", function (e) {
        if (x0 == null) return;
        const dx = e.changedTouches[0].clientX - x0;
        x0 = null;
        if (dx > 40) show(i - 1);
        if (dx < -40) show(i + 1);
      });
    }
    const minus = $("[data-qty-minus]", root);
    const plus = $("[data-qty-plus]", root);
    const qtyEl = $("[data-qty]", root);
    let qty = 1;
    function setQty(n) {
      qty = Math.max(1, n);
      if (qtyEl) qtyEl.textContent = String(qty);
    }
    if (minus) minus.addEventListener("click", function () { setQty(qty - 1); });
    if (plus) plus.addEventListener("click", function () { setQty(qty + 1); });
    const buy = $("[data-pdp-buy]", root);
    $$('[data-pdp-buy]', root).forEach(function (buy) {
      buy.addEventListener('click', function () {
        const slug = root.getAttribute('data-slug') || '';
        const p = YA.getProduct(slug);
        location.href = p && p.url ? p.url : '/search?type=product&q=' + encodeURIComponent(slug.replace(/-/g, ' '));
      });
    });
    $$("[data-pdp-tab]", root).forEach((btn) => {
      btn.addEventListener("click", function () {
        const id = btn.getAttribute("data-pdp-tab");
        $$("[data-pdp-tab]", root).forEach((b) => b.setAttribute("aria-expanded", b === btn ? "true" : "false"));
        $$("[data-pdp-panel]", root).forEach((p) => {
          p.hidden = p.getAttribute("data-pdp-panel") !== id;
        });
      });
    });
  }

  function initCartPage() {
    const root = $("[data-cart-page]");
    if (!root) return;
    if (YA.journey) YA.journey.track("view_cart", { items: YA.cartCount() });
    function linePid(line) {
      return line.productId || String(line.id || "").split(":")[0];
    }
    function paint() {
      const lines = YA.cartLines();
      if (!lines.length) {
        root.innerHTML =
          '<div class="mx-auto flex min-h-[60vh] max-w-3xl flex-col items-center justify-center px-4 py-24 text-center">' +
          '<svg class="mb-4 size-16 text-muted" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="8" cy="21" r="1"></circle><circle cx="19" cy="21" r="1"></circle><path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"></path></svg>' +
          '<h1 class="font-serif text-3xl font-bold">Your Shopping Cart</h1><p class="mt-3 mb-8 text-muted">Your cart is empty. Discover the collection.</p>' +
          '<a href="/collections/all" class="btn btn-primary">Continue Shopping</a></div>';
        return;
      }
      const subtotal = lines.reduce((n, l) => n + l.price * l.qty, 0);
      const mrpTotal = lines.reduce((n, l) => {
        const p = YA.getProduct(linePid(l));
        return n + (p ? p.mrp : l.price) * l.qty;
      }, 0);
      const saved = Math.max(0, mrpTotal - subtotal);
      root.innerHTML =
        '<div class="mx-auto max-w-5xl px-4 py-8 md:py-12"><div class="flex items-end justify-between gap-3"><h1 class="font-serif text-2xl font-bold text-maroon sm:text-3xl">Your Cart (' +
        lines.length +
        ')</h1><p class="inline-flex items-center gap-1.5 text-xs font-semibold tracking-wide text-gold-soft uppercase">Secure Shopping</p></div>' +
        '<div class="mt-6 grid gap-6 lg:grid-cols-3"><div class="space-y-5 lg:col-span-2"><ul class="space-y-3">' +
        lines
          .map((line) => {
            const p = YA.getProduct(linePid(line));
            const href = p ? YA.productHref(p) : "/collections/all";
            return (
              '<li class="flex gap-3 rounded-2xl border border-maroon/10 bg-white p-3 shadow-sm sm:gap-4 sm:p-4">' +
              '<a href="' +
              href +
              '" class="size-20 shrink-0 overflow-hidden rounded-xl bg-cream sm:size-24"><img src="' +
              line.image +
              '" alt="" class="h-full w-full object-cover"></a>' +
              '<div class="flex min-w-0 flex-1 flex-col"><a href="' +
              href +
              '" class="font-serif text-sm font-bold leading-snug text-maroon sm:text-base">' +
              line.title +
              '</a><p class="mt-1 font-clock tracking-wide text-maroon tabular-nums">' +
              YA.formatINR(line.price) +
              '</p><div class="mt-auto flex items-center justify-between pt-2">' +
              '<div class="inline-flex items-center rounded-lg border border-maroon/20">' +
              '<button type="button" class="grid size-9 place-items-center" data-qty-down="' +
              line.id +
              '" aria-label="Decrease">−</button>' +
              '<span class="w-8 text-center text-sm font-bold">' +
              line.qty +
              "</span>" +
              '<button type="button" class="grid size-9 place-items-center" data-qty-up="' +
              line.id +
              '" aria-label="Increase">+</button></div>' +
              '<button type="button" class="grid size-9 place-items-center text-muted hover:text-maroon" data-remove="' +
              line.id +
              '" aria-label="Remove">✕</button></div></div></li>'
            );
          })
          .join("") +
        '</ul></div><aside class="rounded-2xl border border-maroon/10 bg-white p-5 shadow-sm"><p class="font-serif text-lg font-bold text-maroon">Order summary</p>' +
        (saved ? '<p class="mt-2 text-sm text-gold-soft">You save ' + YA.formatINR(saved) + "</p>" : "") +
        '<div class="mt-4 flex justify-between text-sm"><span>Subtotal</span><b class="font-clock">' +
        YA.formatINR(subtotal) +
        '</b></div><div class="mt-2 flex justify-between text-sm"><span>Shipping</span><b class="text-emerald-700">Free prepaid</b></div>' +
        '<div class="mt-4 flex justify-between font-serif text-xl font-bold text-maroon"><span>Total</span><span class="font-clock">' +
        YA.formatINR(subtotal) +
        '</span></div><a class="btn btn-primary mt-6 w-full" href="/order-form' +
        (lines[0] ? "?product=" + encodeURIComponent(linePid(lines[0])) : "") +
        '">Place order</a></aside></div></div>';
    }
    root.addEventListener("click", function (e) {
      const down = e.target.closest("[data-qty-down]");
      const up = e.target.closest("[data-qty-up]");
      const rm = e.target.closest("[data-remove]");
      if (down) {
        const line = YA.cartLines().find((l) => l.id === down.getAttribute("data-qty-down"));
        if (line) YA.cartSetQty(line.id, line.qty - 1);
        paint();
      }
      if (up) {
        const line = YA.cartLines().find((l) => l.id === up.getAttribute("data-qty-up"));
        if (line) YA.cartSetQty(line.id, line.qty + 1);
        paint();
      }
      if (rm) {
        YA.cartRemove(rm.getAttribute("data-remove"));
        paint();
      }
    });
    paint();
  }

  function initTrack() {
    const path = location.pathname.replace(/\.html$/, "");
    const form = $("[data-track-form]") || (path === "/pages/track" ? $("main form") : null);
    if (!form) return;
    const inputs = $$("input", form);
    const idInput = inputs[0];
    const phoneInput = inputs[1];
    let miss = $("[data-track-miss]", form);
    if (!miss) {
      miss = document.createElement("p");
      miss.className = "text-sm text-red-700";
      miss.hidden = true;
      miss.setAttribute("data-track-miss", "");
      const btn = form.querySelector("button[type='submit']");
      if (btn) form.insertBefore(miss, btn);
      else form.appendChild(miss);
    }
    let result = $("[data-track-result]");
    if (!result) {
      result = document.createElement("div");
      result.setAttribute("data-track-result", "");
      form.parentNode.appendChild(result);
    }
    try {
      const last = JSON.parse(sessionStorage.getItem("ya-last-order") || "null");
      if (last) {
        if (idInput && last.orderId) idInput.value = last.orderId;
        if (phoneInput && last.phone) phoneInput.value = String(last.phone).replace(/\D/g, "").slice(-10);
      }
    } catch (e) {}
    function paintOrder(order) {
      miss.hidden = true;
      const items = Array.isArray(order.items)
        ? order.items
        : [{ title: order.product || "Mahayantra", qty: 1, price: order.total || order.amount || 0 }];
      result.innerHTML =
        '<div class="mt-8 rounded-2xl border border-maroon/10 bg-white p-5">' +
        '<p class="text-[11px] font-bold tracking-wide text-gold-soft uppercase">My Yantra</p>' +
        '<p class="mt-1 font-serif text-xl font-bold text-maroon">' +
        escapeHTML(order.customerName || order.fullName || "") +
        "</p>" +
        '<p class="text-sm text-muted">' +
        escapeHTML([order.orderId || "", order.city, order.paymentMethod || "UPI"].filter(Boolean).join(" · ")) +
        "</p>" +
        '<ul class="mt-4 space-y-2 text-sm">' +
        items
          .map(function (i) {
            return (
              '<li class="flex justify-between gap-3"><span>' +
              escapeHTML(i.title || i.product) +
              " × " +
              escapeHTML(i.qty || 1) +
              '</span><span class="font-semibold">' +
              YA.formatINR((i.price || 0) * (i.qty || 1)) +
              "</span></li>"
            );
          })
          .join("") +
        "</ul>" +
        '<p class="mt-3 flex justify-between text-lg text-maroon"><span>Total</span><b class="font-clock">' +
        YA.formatINR(order.total || order.amount || 0) +
        "</b></p>" +
        '<div class="mt-6"><p class="mb-3 font-serif text-lg font-bold text-maroon">Order Status</p>' +
        (YA.orderStages ? YA.orderStages(String(order.stage || order.status || "confirmed").replace(/[^a-z_-]/gi, "")) : "") +
        "</div>" +
        (YA.yantraCareHtml ? YA.yantraCareHtml() : "") +
        '<a class="btn btn-primary mt-5 w-full" href="' +
        escapeHTML(YA.waUrl("Namaskaram. Tracking order " + (order.orderId || "") + " for " + (order.customerName || order.fullName || ""))) +
        '">WhatsApp the ashram</a></div>';
    }
    form.addEventListener("submit", async function (e) {
      e.preventDefault();
      const orderId = (idInput ? idInput.value : "").trim();
      const mobile = (phoneInput ? phoneInput.value : "").replace(/\D/g, "");
      miss.hidden = true;
      result.innerHTML = "";
      const btn = form.querySelector("button[type='submit']");
      if (btn) btn.disabled = true;
      try {
        const res = await fetch("https://www.yogiadhiraajproducts.in/api/order.php?orderId=" + encodeURIComponent(orderId) + "&phone=" + encodeURIComponent(mobile));
        const json = await res.json();
        if (json && json.ok && json.order) {
          paintOrder(json.order);
          if (btn) btn.disabled = false;
          return;
        }
      } catch (err) {}
      try {
        const last = JSON.parse(sessionStorage.getItem("ya-last-order") || "null");
        if (
          last &&
          (!orderId || String(last.orderId).toUpperCase() === orderId.toUpperCase()) &&
          (!mobile || String(last.phone || last.mobile || "").replace(/\D/g, "").endsWith(mobile.slice(-10)))
        ) {
          paintOrder(last);
          if (btn) btn.disabled = false;
          return;
        }
      } catch (err) {}
      miss.textContent =
        "No order matched that ID and mobile. Check the WhatsApp confirmation, or write to info@yogiadhiraaj.in / +91 90168 72214 with both details.";
      miss.hidden = false;
      if (btn) btn.disabled = false;
    });
  }

  function initAutoKmm() {
    if (!$("[data-kmm]")) return;
    if (wantsKmm()) YA.openKnowMahayantra();
  }

  function initIntentFlash() {
    $$(".intent-tile").forEach(function (el) {
      el.addEventListener("pointerdown", function () {
        el.classList.remove("is-pressed");
        void el.offsetWidth;
        el.classList.add("is-pressed");
        window.setTimeout(function () {
          el.classList.remove("is-pressed");
        }, 320);
      });
    });
  }


  function hydrateSnapCardPrices() {
    $$(".pcard").forEach(function (card) {
      const a = card.querySelector("a[href*='/product/'], a[href*='yantra'], a[href*='vajra']");
      const href = a ? a.getAttribute("href") || "" : "";
      const slug = (href.split("/products/")[1] || href.replace(/^\//, "")).split("?")[0];
      if (!slug) return;
      const p = YA.getProduct(slug);
      if (!p) return;
      const widget = card.querySelector("[data-save-deal]");
      if (widget) {
        widget.setAttribute("data-sale", String(p.sale));
        widget.setAttribute("data-mrp", String(p.mrp));
        widget.removeAttribute("data-deal-ready");
        buildSaveDeal(widget);
        refreshSaveDeal(widget, true);
        return;
      }
      const saleEl = card.querySelector("[data-sale]");
      const mrpEl = card.querySelector("[data-mrp]");
      const claimed = YA.isDealClaimed();
      if (saleEl && saleEl.hasAttribute("data-mrp")) {
        saleEl.innerHTML = claimed
          ? "<s>" + YA.formatINR(p.mrp) + "</s><b>" + YA.formatINR(p.sale) + "</b>"
          : "<b>" + YA.formatINR(p.mrp) + "</b>";
      } else {
        if (saleEl) saleEl.textContent = YA.formatINR(claimed ? p.sale : p.mrp);
        if (mrpEl && p.mrp) mrpEl.textContent = YA.formatINR(p.mrp);
      }
    });
  }

  function initSpot() {
    $$("[data-spot]").forEach(function (el) {
      if (el.querySelector("article.pcard, .pcard")) return;
      const key = el.getAttribute("data-spot");
      const ids = key === "bogo" ? (YA.BOGO_SPOTLIGHT || []) : (YA.BEST_IDS || []);
      if (!ids.length) return;
      el.innerHTML = ids
        .map(function (id) {
          const p = YA.getProduct(id);
          return p && YA.cardHtml ? YA.cardHtml(p, key === "best") : "";
        })
        .join("");
    });
  }

  function hideMobileDock() {
    const path = location.pathname.replace(/\.html$/, "");
    const hide =
      ["/cart", "/login", "/order-form", "/success", "/thank-you", "/order-confirmation", "/payment-failed", "/pages/contact"].some(
        function (p) {
          return path === p || path.indexOf(p + "/") === 0;
        }
      ) || path.indexOf("/products/") === 0;
    const dock = $('nav[aria-label="Quick actions"]');
    if (dock && hide) dock.hidden = true;
  }

  YA.orderStages = function (here) {
    const stages = [
      ["confirmed", "Order Confirmed", "The ashram has received your sankalpa"],
      ["preparation", "Preparation", "The workshop selects and prepares your instrument"],
      ["energization", "Energization / Puja", "Janm-based consecration, typically 7 to 14 working days"],
      ["quality", "Quality Check", "The finished piece is reviewed before packing"],
      ["packaging", "Packaging", "Packed with care for a sacred instrument"],
      ["dispatched", "Dispatched", "Handed to courier from Madikeri"],
      ["delivered", "Delivered", "Yantra reached your home"],
      ["guidance", "Placement guidance", "Keep on a clean, elevated surface. Wipe with a soft dry cloth."],
    ];
    const key = here === "utr_reported" || here === "verified" ? "confirmed" : here || "confirmed";
    let idx = stages.findIndex(function (s) { return s[0] === key; });
    if (idx < 0) idx = 0;
    return (
      '<ol class="order-timeline" aria-label="Order status">' +
      stages
        .map(function (s, i) {
          const cls = i < idx ? "is-done" : i === idx ? "is-here" : "";
          return (
            '<li class="' +
            cls +
            '"><span class="order-dot" aria-hidden></span><div><p class="font-serif text-sm font-bold text-maroon">' +
            s[1] +
            '</p><p class="text-xs leading-snug text-muted">' +
            s[2] +
            "</p></div></li>"
          );
        })
        .join("") +
      "</ol>"
    );
  };
  YA.yantraCareHtml = function () {
    return (
      '<div class="mt-6 space-y-3 border-t border-maroon/10 pt-5">' +
      '<p class="font-serif text-lg font-bold text-maroon">Placement and care</p>' +
      '<p class="text-sm leading-relaxed text-muted">Place the instrument on a clean, elevated surface facing east or north if that is the custom of your home. A simple lamp may be offered. This is a spiritual instrument prepared in the ashram tradition — not a medical, financial or guaranteed outcome.</p>' +
      '<p class="text-sm leading-relaxed text-muted">Keep dry. Wipe with a soft cloth. Do not use chemicals or immerse in water. WhatsApp the ashram if you wish for placement notes for your specific piece.</p>' +
      "</div>"
    );
  };

  function loadLastOrder() {
    try {
      const raw = sessionStorage.getItem("ya-last-order") || localStorage.getItem("ya-last-order");
      if (raw) return JSON.parse(raw);
    } catch (e) {}
    try {
      const hist = JSON.parse(localStorage.getItem("ya-orders") || "[]");
      if (hist && hist[0]) return hist[0];
    } catch (e) {}
    return null;
  }

  function initConfirmPage() {
    const mount = $("[data-confirm-page]");
    if (!mount) return;
    const order = loadLastOrder() || {};
    const name = order.customerName || order.fullName || order.name || "";
    const oid = order.orderId || order.id || "";
    const product = order.product || (order.items && order.items[0] && (order.items[0].title || order.items[0].en)) || "Mahayantra";
    mount.innerHTML =
      '<div class="mx-auto max-w-xl px-4 py-16">' +
      '<div class="rounded-3xl border border-gold/35 bg-white p-8 shadow-[0_24px_60px_#7a1e1e14]">' +
      '<p class="text-center text-[11px] font-semibold tracking-[0.32em] text-gold-soft uppercase">Yogi Adhiraaj Sansthaanam</p>' +
      '<h1 class="mt-3 text-center font-serif text-3xl font-bold text-maroon">Thank you' +
      (name ? ", " + String(name).split(" ")[0] : "") +
      "</h1>" +
      '<p class="mt-2 text-center text-sm text-muted">Your order is booked. The ashram has received your sankalpa.</p>' +
      '<div class="mt-6 space-y-3 border-t border-maroon/10 pt-5 text-sm">' +
      '<p><span class="text-[11px] font-bold tracking-wide text-muted uppercase">Order</span><span class="mt-0.5 block font-semibold text-maroon">' +
      (oid || "We will write with your order id") +
      '</span></p><p><span class="text-[11px] font-bold tracking-wide text-muted uppercase">Offering</span><span class="mt-0.5 block font-semibold">' +
      product +
      '</span></p><p><span class="text-[11px] font-bold tracking-wide text-muted uppercase">Payment</span><span class="mt-0.5 block font-semibold">' +
      (order.paymentMethod || "UPI") +
      '</span></p><div class="flex justify-between pt-1 text-lg text-maroon"><span class="font-serif font-bold">Total</span><span class="font-clock tracking-wide tabular-nums">' +
      YA.formatINR(order.total || order.amount || 0) +
      "</span></div></div>" +
      '<div class="mt-6"><p class="mb-3 font-serif text-lg font-bold text-maroon">Order Status</p>' +
      (YA.orderStages ? YA.orderStages(order.stage || "confirmed") : "") +
      "</div>" +
      (YA.yantraCareHtml ? YA.yantraCareHtml() : "") +
      '<a href="' +
      YA.waUrl("Please share the status of order " + oid) +
      '" target="_blank" rel="noopener noreferrer" class="mt-3 flex min-h-12 items-center justify-center gap-2 rounded-xl bg-[#25d366] font-bold text-white">Track Order on WhatsApp</a>' +
      '<a href="/" class="btn btn-primary mt-3 min-h-12 w-full">Continue Shopping</a></div></div>';
  }

  function initLoginPage() {
    const path = location.pathname.replace(/\.html$/, "");
    if (path !== "/login") return;
    const user = googleUser();
    const mount = $("[data-login-auth]");
    if (!mount) return;
    if (user) {
      mount.innerHTML =
        '<div class="flex flex-col items-center gap-4"><p class="text-sm text-muted">You are already signed in.</p>' +
        '<p class="font-semibold text-maroon">' +
        (user.name || user.email) +
        "</p>" +
        '<a href="/" class="text-sm font-semibold text-maroon underline decoration-gold underline-offset-4">Return to the ashram</a></div>';
    } else if (!mount.querySelector("[data-google-form]")) {
      mount.innerHTML = googleFormInner().replace('class="mt-8 space-y-3"', 'class="space-y-3"');
      bindGoogleForm(mount.querySelector("[data-google-form]"));
    }
  }

  document.addEventListener("click", function (e) {
    const a = e.target.closest("a[href*='wa.me']");
    if (!a) return;
    try {
      sessionStorage.setItem("ya-hold-skip", String(Date.now() + 20000));
    } catch (err) {}
  });

  function isPageHref(href) {
    if (!href) return false;
    href = String(href).trim();
    if (!href || href === "#" || href.indexOf("javascript:") === 0) return false;
    if (href.indexOf("tel:") === 0 || href.indexOf("mailto:") === 0 || href.indexOf("upi:") === 0) return false;
    if (href.charAt(0) === "#" ) return false;
    return true;
  }
  function initInstantNav() {
    document.addEventListener(
      "click",
      function (e) {
        if (e.defaultPrevented) return;
        if (e.button && e.button !== 0) return;
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        const a = e.target.closest("a[href]");
        if (!a) return;
        if (a.target && a.target !== "" && a.target !== "_self") return;
        const href = a.getAttribute("href") || "";
        if (!isPageHref(href)) return;
        clearChrome();
      },
      true
    );
    window.addEventListener("pageshow", function () {
      clearChrome();
    });
    window.addEventListener("pagehide", function () {
      lockScroll(false);
    });
  }

  function initActiveNavigation() {
    const current = location.pathname.replace(/\/$/, '') || '/';
    $$('.ya-ref header nav a[href], .cat-pages a[href]').forEach(function (link) {
      const url = new URL(link.href, location.origin);
      const path = url.pathname.replace(/\/$/, '') || '/';
      if (url.origin !== location.origin || url.hash) return;
      if (path === current) link.setAttribute('aria-current', 'page');
      else if (link.getAttribute('aria-current') === 'page') link.removeAttribute('aria-current');
    });
  }

  document.addEventListener('click', function (event) {
    const target = event.target.closest('a[data-checkout],button[data-checkout],a[href^="/checkout?add="],a[href^="/order-form?"]');
    if (!target) return;
    event.preventDefault();
    const url = new URL(target.getAttribute('href') || location.href, location.origin);
    const slug = url.searchParams.get('add') || url.searchParams.get('product') ||
      (document.querySelector('[data-slug]') || {}).getAttribute?.('data-slug') || '';
    const p = YA.getProduct(slug);
    location.href = p && p.url ? p.url : '/search?type=product&q=' + encodeURIComponent(slug.replace(/-/g, ' '));
  }, true);

  document.addEventListener("DOMContentLoaded", function () {
    function boot(fn) {
      try {
        fn();
      } catch (e) {}
    }
    boot(initInstantNav);
    boot(initActiveNavigation);
    boot(paintCart);
    boot(initHeaderBrand);
    boot(hydrateSnapCardPrices);
    boot(initDeal);
    boot(initHero);
    boot(initMenu);
    boot(initSearch);
    boot(initCoupon);
    boot(initKmm);
    boot(initGoogle);
    boot(initHold);
    boot(initAccordions);
    boot(initQuiz);
    boot(initShop);
    boot(initSpot);
    boot(initFind);
    boot(initContact);
    boot(initSubscribe);
    boot(initProduct);
    boot(initCartPage);
    boot(initTrack);
    boot(initAutoKmm);
    boot(initIntentFlash);
    boot(hideMobileDock);
    boot(initConfirmPage);
    boot(initLoginPage);
    if (!anySheetOpen()) lockScroll(false);
  });
})();
